import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    Injector,
    Compiler,
    NgModuleRef,
    NgModule,
    ViewChild,
    ViewContainerRef,
    ComponentRef,
    ElementRef,
    Input,
    Inject
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclSideNavItem,
    CclMessageService,
    CclNotifyService,
    CclPopupService,
    CclSharedModule
} from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";
import { Subscription } from "rxjs";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import { SpeakerService } from "../../../../modules/shared/services/speaker.service";
import { SessionService } from "../../../../modules/shared/services/session-service";
import * as mustache from "mustache";
import { SharedModule } from "../../../shared-module/shared-module";
import { CommonModule, DatePipe } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import * as FileSaver from "file-saver";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";
import { CookieService, CookieOptions } from "ngx-cookie";
import { FlashMessagesService } from "angular2-flash-messages";
import { uniq } from 'lodash';

@Component({
    selector: "session-section",
    templateUrl: "./session-section.view.html",
    styleUrls: []
})
export class SessionSectionView implements OnInit, AfterViewInit, OnDestroy {
    private speakerList = {};
    private mustache = mustache;
    private output = "";
    private subscription: Subscription;
    private subscription2: Subscription;

    private highlightedSpeakerConfig = { labelConfig: {} };
    private promotedSessionConfig = { labelConfig: {} };
    public generalSpeakerConfig: any = { labelConfig: {} };
    private speakerGroupList: any;
    private keysSession: any;
    private speakerArrangedList: any;
    highlightedDataConfig: any;
    private promotedDataConfig: any;
    private generalDataConfig: any;
    private timeFilter: any;
    searchBarText: any;
    private sessionFilter: any = {};

    private showCarousel = false;
    private highlightedHasSlide: boolean = false;
    private promotedHasSlide: boolean = false;
    private highlightedStyle;
    private promotedStyle;
    private speakerStyle;
    private speakerSessionConfig;
    private speakerHtml = "";
    private bindSpeakerSessionListClick = true;
    bindSpeakerBioClick = true;
    private speakerClickHandler;
    private filters: any = {};
    esPage = 0;
    private loadingList = true;
    private clearGeneralSessionList = false;
    private nospeakersAvailable = false;
    private isLoggedIn: boolean = false;
    private showMySessions: boolean = false;
    private showMyFav: boolean = false;
    private filterConfig: any;
    private buttonConfig: any;
    private userPreferenceCookie: any = null;
    private downloadSpeakerDocument;
    private downloadSessionDocument;
    private customFieldDdfRegx = new RegExp("({@ddf.customFieldMap.)(.*?)(?=@)", "g");
    private prevGroupingLevels = { topLevel: "" };
    private currentGroupingLevels = { topLevel: "" };
    public speakerInfo = true;
    private param: any = {};
    private bioLayout: any;

    highlightedCarousel = [{ content: "<div></div>" }];
    promotedCarousel = [{ content: "<div></div>" }];
    defaultFilters: any = {};
    defaultCurrencySymbol: string;

    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true
    };

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private attendeeSessionService: AttendeeSessionService,
        private compiler: Compiler,
        private injector: Injector,
        private moduleRef: NgModuleRef<any>,
        private datePipe: DatePipe,
        public ngxSmartModalService: NgxSmartModalService,
        private messageService: CclMessageService,
        private notifyService: CclNotifyService,
        private cookieService: CookieService,
        private _flashMessagesService: FlashMessagesService,
        private popupService: CclPopupService,
        private speakerService: SpeakerService,
        private sessionService: SessionService,
        private elementRef: ElementRef
    ) {
        this.defaultCurrencySymbol = this.sharedService.event.currencySymbol || this.sharedService.currencySymbol;
        if (this.cookieService.get("catalog_" + this.sharedService.setup.id) != undefined) {
            this.userPreferenceCookie = JSON.parse(this.cookieService.get("catalog_" + this.sharedService.setup.id));
            this.showHtmlTop = this.userPreferenceCookie.showHtmlTop;
        }

        this.navSecondaryService.includeSave = false;
        this.highlightedSpeakerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SPEAKER.highlighted].config
        );

        this.speakerSessionConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SPEAKER_SESSION_CONFIG].config
        );

        this.highlightedDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.highlighted].config
        );

        this.generalSpeakerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SPEAKER.general].config
        );
       
        if(!this.generalSpeakerConfig.catalogConfig.hasOwnProperty('searchBarText')) {
            this.searchBarText = 'Enter a Search term to find Speakers...'
        } else {
            this.searchBarText = this.generalSpeakerConfig.catalogConfig.searchBarText;
        }
        this.speakerStyle = this.createStyleString2(this.generalSpeakerConfig["catalogConfig"].body);

        this.speakerClickHandler = function(event) {
            this.getSessionsBySpeaker();
        };

        this.downloadSpeakerDocument = function(event) {
            event.stopPropagation();
            let documentName = $(event.srcElement).attr("data-filename");
            let documentType = $(event.srcElement).attr("data-documentType");
            let speakerId = $(event.srcElement).attr("data-speakerId");
            let eventId = $(event.srcElement).attr("data-eventId");

            attendeeSessionService
                .downloadSpeakerDocument(eventId, documentName, documentType, speakerId)
                .subscribe((resp) => {
                    FileSaver.saveAs(resp.body, documentName);
                });
        };

        this.downloadSessionDocument = function(event) {
            event.stopPropagation();
            let documentName = $(event.srcElement).attr("data-filename");
            let documentType = $(event.srcElement).attr("data-documentType");
            let sessionId = $(event.srcElement).attr("data-sessionId");
            let eventId = $(event.srcElement).attr("data-eventId");

            attendeeSessionService
                .downloadSessionDocument(eventId, documentName, documentType, sessionId)
                .subscribe((resp) => {
                    FileSaver.saveAs(resp.body, documentName);
                });
        };

        this.subscription = this.messageService.getMessage().subscribe((message) => this.listenMessage(message));

        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );
        }
        this.sharedService["onScroll"] = this.onScroll.bind(this);
    }

    highlightedLoaded: boolean;
    promotedLoaded: boolean;
    fromAttendee: boolean = false;
    showHighlighted: boolean = false;
    showPromoted: boolean = false;
    showHtmlTop: boolean = true;

    getLoggedInAttendee() {
        // let attendeeIdCookie = this.cookieService.get("attendeeId_" + this.sharedService.setup.id);
        let attendeeUUIDCookie = this.cookieService.get("attendeeUUID_" + this.sharedService.setup.id);
        if (!this.sharedService.isEmptyString(attendeeUUIDCookie)) {
            this.attendeeSessionService.getRegistrationByUUID(attendeeUUIDCookie).subscribe((resp) => {
                let reg = resp.body["registrationDTO"];
                if (reg.id != null && reg.eventId == this.sharedService.event.id) {
                    this.sharedService.loggedInAttendee = resp.body["registrationDTO"];
                    sessionStorage.setItem(
                        "loggedInAttendee_" + this.sharedService.eventUUID,
                        JSON.stringify(this.sharedService.loggedInAttendee)
                    );
                    this.attendeeSessionService.getSessionApiOnLogin();
                    this.isLoggedIn = true;
                    this.esPage = 0;
                    if (this.generalList != null) {
                        this.generalList.clear();
                    }
                    // this.filters.registrationId = this.sharedService.loggedInAttendee.id;
                    this.filters.registrationUUID = this.sharedService.loggedInAttendee.uuid;

                    this.filters["attendeeTypeIds"] = [];
                    this.filters.attendeeTypeIds.push(reg.type.id);

                    this.getSpeakerList();
                } else {
                    this.getSpeakerList();
                }
            });
        } else {
            this.getSpeakerList();
        }
    }

    createSpeakerSessionsTemplate(imgStyle, textStyleStr, output2, speaker, imageBasedOn, bannerImage) {
        textStyleStr = textStyleStr + ";box-sizing: border-box;padding-right: 15px";
        if (this.param["speakerSessionLayout"] != "l_noimage" && this.param["speakerSessionLayout"] != "l_banner") {
            let imagePath = "assets/images/blank_profile.jpg";
            if (imageBasedOn === "speaker_img" && speaker != undefined) {
                if (speaker.profilePicURL != "" && speaker.profilePicURL != null) {
                    imagePath = speaker.profilePicURL;
                }
            }
            if (imageBasedOn === "dynamic_img") {
                if (this.param["speakerDynamicImg"] != "") {
                    imagePath = this.param["speakerDynamicImg"];
                }
            }
            return (
                '<div class="attendee-session-list-img-container speaker-session-catalog-body-container catalog-img-container">' +
                '<img alt="Speaker Image" class="speaker-session-catalog-body-img"' +
                'src="' +
                imagePath +
                '"></div>' +
                "<div class='attendee-session-list-text-container speaker-session-catalog-text' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        } else {
            return (
                (this.param["speakerSessionLayout"] === "l_banner" && bannerImage != undefined
                    ? '<div><img alt="Banner Image" class="speaker-session-catalog-body-img" src="' +
                      bannerImage +
                      '"></div>'
                    : "") +
                "<div class='attendee-session-list-text-container speaker-session-catalog-text' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        }
    }

    getSpeakerPopUpData(tab) {
        var datePipe = this.datePipe;
        var dateFormat = "EEEE, MMMM dd";
        var timeFormat = "hh:mm a";
        if (tab === "speakerInfo") {
            this.removeBindedClickFromSessionList();
            this.speakerInfo = true;
            this.bindSpeakerSessionListClick = true;
        } else {
            this.removeBindedClickFromSpeakerBio();
            if (!this.ngxSmartModalService.getModalData("myModal").sessionList) {
                this.param["speakerForSession"] = this.ngxSmartModalService.getModalData("myModal").speakerInfo.speaker;
                var filter: any = {};
                filter.isPublished = true;
                filter.page = 0;
                filter.limit = 100;
                filter["speakerIds"] = [this.ngxSmartModalService.getModalData("myModal").speakerInfo.speakerId];
                this.attendeeSessionService.getSessions(filter).subscribe(
                    (resp) => {
                        if (resp.hasOwnProperty("body") && resp.body["sessions"].length > 0) {
                            var speakerSessionList = {
                                sessions: resp.body["sessions"],
                                formatDateTime: function() {
                                    return function(date, render) {
                                        return datePipe.transform(
                                            render(date).replace(new RegExp(" ", "g"), "T"),
                                            dateFormat + "," + timeFormat
                                        );
                                    };
                                },
                                formatTime: function() {
                                    return function(date, render) {
                                        return datePipe.transform(
                                            render(date).replace(new RegExp(" ", "g"), "T"),
                                            timeFormat
                                        );
                                    };
                                },
                                formatDate: function() {
                                    return function(date, render) {
                                        return datePipe.transform(
                                            render(date).replace(new RegExp(" ", "g"), "T"),
                                            dateFormat
                                        );
                                    };
                                },
                                presentations: function() {
                                    return function(text, render) {
                                        var arr = text.split("{@ddf@}");
                                        if (render(arr[0]) === "Non-Abstract") {
                                            return render(arr[1]);
                                        }
                                    };
                                }
                            };
                            this.param["speakerSessionStyleStr"] = this.param["speakerSessionStyleStr"].replace(
                                /,/g,
                                "; "
                            );
                            this.param["speakerSessionStyleStr"] = this.param["speakerSessionStyleStr"].replace(
                                /[{}']/g,
                                ""
                            );
                            this.param["speakerSessionStyleStr"] = this.param["speakerSessionStyleStr"].replace(
                                /,/g,
                                "; "
                            );
                            this.param["speakerSessionStyleStr"] = this.param["speakerSessionStyleStr"].replace(
                                /[{}']/g,
                                ""
                            );

                            this.param["speakerSessionTextStyleStr"] = this.param["speakerSessionTextStyleStr"].replace(
                                /[{}']/g,
                                ""
                            );
                            this.param["speakerSessionTextStyleStr"] = this.param["speakerSessionTextStyleStr"].replace(
                                /,/g,
                                "; "
                            );
                            this.param["speakerSessionTextStyleStr"] = this.param["speakerSessionTextStyleStr"].replace(
                                /,/g,
                                "; "
                            );
                            this.param["speakerSessionTextStyleStr"] = this.param["speakerSessionTextStyleStr"].replace(
                                /[{}']/g,
                                ""
                            );

                            this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace(
                                new RegExp("{@ddf.startDate@}", "g"),
                                "{@ddf.#formatDate@}{@ddf.startTime@}{@ddf./formatDate@}"
                            );

                            this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace(
                                new RegExp("{@ddf.startTimeHHmm@}", "g"),
                                "{@ddf.#formatTime@}{@ddf.startTime@}{@ddf./formatTime@}"
                            );

                            this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace(
                                new RegExp("{@ddf.startDateTime@}", "g"),
                                "{@ddf.#formatDateTime@}{@ddf.startTime@}{@ddf./formatDateTime@}"
                            );

                            this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace(
                                new RegExp("{@ddf.endDate@}", "g"),
                                "{@ddf.#formatDate@}{@ddf.endTime@}{@ddf./formatDate@}"
                            );

                            this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace(
                                new RegExp("{@ddf.endTimeHHmm@}", "g"),
                                "{@ddf.#formatTime@}{@ddf.endTime@}{@ddf./formatTime@}"
                            );

                            this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace(
                                new RegExp("{@ddf.endDateTime@}", "g"),
                                "{@ddf.#formatDateTime@}{@ddf.endTime@}{@ddf./formatDateTime@}"
                            );

                            var output = mustache.render(
                                '{@ddf.#sessions@}<div class="speaker-session-list speaker-session-catalog-body ' +
                                    (this.param["speakerSessionLayout"] != "l_banner"
                                        ? "attendee-session-list-container"
                                        : "") +
                                    '">' +
                                    this.createSpeakerSessionsTemplate(
                                        this.param["speakerSessionImgStyle"],
                                        this.param["speakerSessionTextStyleStr"],
                                        this.param["speakerSessionTemplate"],
                                        this.param["speakerForSession"],
                                        this.param["speakerImgBasedOn"],
                                        this.param["speakerSessionBanner"]
                                    ) +
                                    "</div>{@ddf./sessions@}",
                                speakerSessionList
                            );

                            const modalData: Object = {
                                sessionList: output,
                                speakerInfo: this.ngxSmartModalService.getModalData("myModal").speakerInfo
                            };

                            this.ngxSmartModalService.setModalData(modalData, "myModal", true);
                            this.speakerInfo = false;
                            this.bindSpeakerBioClick = true;
                        } else {
                            const modalData: Object = {
                                sessionList:
                                    "<div class='speaker-session-list--empty'>There are no sessions for this speaker</div>",
                                speakerInfo: this.ngxSmartModalService.getModalData("myModal").speakerInfo
                            };

                            this.ngxSmartModalService.setModalData(modalData, "myModal", true);
                            this.speakerInfo = false;
                            this.bindSpeakerBioClick = true;
                        }
                    },
                    (err) => {
                        const modalData: Object = {
                            sessionList: "Unable to load speaker session data",
                            speakerInfo: this.ngxSmartModalService.getModalData("myModal").speakerInfo
                        };

                        this.ngxSmartModalService.setModalData(modalData, "myModal", true);
                    }
                );
            } else {
                this.speakerInfo = false;
                this.bindSpeakerBioClick = true;
            }
        }
    }

    setCookie() {
        var d = new Date();
        d.setFullYear(d.getFullYear() + 1);
        var cookieOptions: CookieOptions = {
            expires: d
        };
        var obj: Object = {
            showHighlighted: this.showHighlighted,
            showPromoted: this.showPromoted,
            showHtmlTop: this.showHtmlTop
        };
        this.cookieService.putObject("catalog_" + this.sharedService.setup.id, obj, cookieOptions);
    }

    toggleHighlighted() {
        this.showHighlighted = !this.showHighlighted;
        this.setCookie();
    }

    togglePromoted() {
        this.showPromoted = !this.showPromoted;
        this.setCookie();
    }

    onScroll() {
        if (this.loadingList == false && this.nospeakersAvailable == false && this.esPage > 0) {
            this.filterResults = true;
            this.sharedService.showLoader = false;
            this.loadingList = true;
            this.getSpeakerList();
        }
    }

    getSessionsBySpeaker() {
        var speaker = this.ngxSmartModalService.getModalData("myModal")["speakerData"];
        this.esPage = 0;
        this.sharedService.speakerFilterApplied = true;
        this.messageService.sendMessage("clear-all-filter");
        this.filters["speakerIds"] = [speaker.id];
        this.filters["trackIds"] = this.defaultFilters.trackIds;
        this.filters["typeIds"] = this.defaultFilters.typeIds;
        this.nospeakersAvailable = false;
        this.getSpeakerList();
    }

    bindClick() {
        this.speakerClickHandler = this.getSessionsBySpeaker.bind(this);
        this.downloadSpeakerDocument = this.downloadSpeakerDocument.bind(this);
        if (document.getElementById("speakerSession") != null) {
            document.getElementById("speakerSession").addEventListener("click", this.speakerClickHandler);
            this.bindSpeakerSessionListClick = false;
        }

        var sessionFiles = document.getElementsByClassName("sessionFiles");
        if (sessionFiles != null && sessionFiles.length > 0) {
            for (let i = 0; i < sessionFiles.length; i++) {
                sessionFiles[i].addEventListener("click", this.downloadSessionDocument);
            }
            this.bindSpeakerSessionListClick = false;
        }

        return false;
    }

    bindBioClick() {
        var speakerCustomFiles = document.getElementsByClassName("speakerCustomFile");
        if (speakerCustomFiles != null && speakerCustomFiles.length > 0) {
            for (let i = 0; i < speakerCustomFiles.length; i++) {
                speakerCustomFiles[i].addEventListener("click", this.downloadSpeakerDocument);
            }
            this.bindSpeakerBioClick = false;
        }

        return false;
    }

    onModalClose() {
        this.removeBindedClickFromSessionList();
        this.removeBindedClickFromSpeakerBio();
    }

    removeBindedClickFromSessionList() {
        if (this.bindSpeakerSessionListClick) {
            if (document.getElementsByClassName("sessionFiles") != null) {
                var sessionFiles = document.getElementsByClassName("sessionFiles");
                for (let i = 0; i < sessionFiles.length; i++) {
                    sessionFiles[i].removeEventListener("click", this.downloadSessionDocument);
                }
                this.bindSpeakerSessionListClick = false;
            }
            if (this.bindSpeakerSessionListClick === true) {
                this.bindSpeakerSessionListClick = false;
            }
        }
    }

    removeBindedClickFromSpeakerBio() {
        if (this.bindSpeakerBioClick) {
            if (document.getElementsByClassName("speakerCustomFile") != null) {
                var speakerCustomFiles = document.getElementsByClassName("speakerCustomFile");
                for (let i = 0; i < speakerCustomFiles.length; i++) {
                    speakerCustomFiles[i].removeEventListener("click", this.downloadSpeakerDocument);
                }
                this.bindSpeakerBioClick = false;
            }
            if (this.bindSpeakerBioClick === true) {
                this.bindSpeakerBioClick = false;
            }
        }
    }

    onModalOpen() {
        this.speakerInfo = true;
        if (this.bindSpeakerSessionListClick === false) {
            this.bindSpeakerSessionListClick = true;
        }
        if (this.bindSpeakerBioClick === false) {
            this.bindSpeakerBioClick = true;
        }
    }

    listenMessage(message) {
        if (message.text == "apply-session-filters") {
            this.filterResults = true;
            this.clearGeneralSessionList = true;
            this.nospeakersAvailable = false;
            this.esPage = 0;
            let cfFilter = {};
            for (let prop in this.sharedService.selectedFilterData) {
                let esProp = "";
                if (prop === "sessionDate") {
                    esProp = "startDates";
                } else if (prop === "track") {
                    esProp = "trackIds";
                } else if (prop === "sessionType") {
                    esProp = "typeIds";
                } else if (prop === "location") {
                    esProp = "locationIds";
                } else if (prop === "speaker") {
                    esProp = "speakerIds";
                } else if (prop === "sessionTime") {
                    esProp = "startTimes";
                } else if (prop === "tag") {
                    esProp = "tagIds";
                } else if (prop === "sessionLevel") {
                    esProp = "sessionLevelIds";
                } else if (prop.indexOf("customField_") > -1) {
                    esProp = "customFieldOptions";
                    cfFilter[prop] = [];
                } else {
                    esProp = prop;
                }
                this.filters[esProp] = [];
                let arr = [];
                for (let prop2 in this.sharedService.selectedFilterData[prop]) {
                    if (this.sharedService.selectedFilterData[prop][prop2] === true) {
                        this.sharedService.filterData[prop].forEach((element) => {
                            if (element.id + "" === prop2) {
                                if (prop === "sessionDate") {
                                    this.filters[esProp].push(this.datePipe.transform(element.id, "yyyy-MM-dd"));
                                } else if (prop.indexOf("customField_") > -1) {
                                    cfFilter[prop].push(element.id);
                                } else if (prop === "sessionTime") {
                                    this.filters[esProp].push(
                                        this.datePipe.transform("Tue Jan 22 2019 " + element.id, "HH:mm")
                                    );
                                } else {
                                    this.filters[esProp].push(element.id);
                                }
                            }
                        });
                    }
                }
            }
            let cfFilter2 = {};
            for (let prop in cfFilter) {
                cfFilter2[prop.replace("customField_", "")] = cfFilter[prop];
            }
            this.filters.customFieldOptions = cfFilter2;
            if (!this.noSpeakersInCatalog) {
                this.getSpeakerList();
            }
        }
        if (message.text == "clear-text-search-field") {
            this.sessionFilter.query = "";
            delete this.filters.sessionName;
        }
        if (message.text == "attendee-login") {
            this.isLoggedIn = true;
            this.esPage = 0;
            if (this.generalList != null) {
                this.generalList.clear();
            }
            // this.filters.registrationId = this.sharedService.loggedInAttendee.id;
            this.filters.registrationUUID = this.sharedService.loggedInAttendee.uuid;

            this.nospeakersAvailable = false;
            this.getSpeakerList();
        }
        if (message.text == "attendee-logout") {
            this.isLoggedIn = false;
            this.esPage = 0;
            if (this.generalList != null) {
                this.generalList.clear();
            }
            delete this.filters.registrationId;
            delete this.filters.registrationUUID;
            delete this.filters.attendeeTypeIds;
            delete this.filters.fetchFavInstanceList;
            delete this.filters.mySessions;
            this.nospeakersAvailable = false;
            this.getSpeakerList();
        }
        if (message.text == "apply-mysession-checkbox") {
            this.mySessionCheckbox();
        }
        if (message.text == "apply-myfavsession-checkbox") {
            this.myFavCheckbox();
        }
        if (message.text == "apply-mysession-clearAll") {
            this.mySessionFilterClear();
        }
        if (message.text == "toggle-html-top") {
            this.showHtmlTop = message.data;
            this.setCookie();
        }
        if (message.text == "unhide-sessions") {
            this.filters["deleteExcludedAndFetch"] = true;
            this.esPage = 0;
            this.nospeakersAvailable = false;
            if (this.generalList != null) {
                this.generalList.clear();
            }
            this.getSpeakerList();
        }
        if (message.text == "changed-tab") {
            this.esPage = 0;
            this.clearGeneralSessionList = true;
            this.nospeakersAvailable = false;
            this.filterResults = true;
            if (!message.data.cfId) {
                if (message.data == "allSpeakerTypes") {
                    delete this.filters["speakerTypeIds"];
                    delete this.filters["customFieldOptions"];
                } else {
                    this.filters["speakerTypeIds"] = [message.data.id];
                }
            } else {
                this.filters = {
                    customFieldOptions: {
                        [message.data.cfId]: [message.data.id]
                    }
                };
            }
            this.getSpeakerList();
        }
    }

    private filterResults: boolean = false;
    noSpeakersInCatalog: boolean = false;
    noHighLightedSpeakers: boolean = false;
    noPromotedSessions: boolean = false;

    clickTextSearch() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.nospeakersAvailable = false;
        this.filterResults = true;
        this.filters["textQuery"] = this.sessionFilter.query;
        this.getSpeakerList();
    }

    clickRemoveFilter() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.nospeakersAvailable = false;
        this.filterResults = true;
        delete this.filters["textQuery"];
        this.sessionFilter.query = "";
        this.getSpeakerList();
    }

    getHighlightedAndPromotedSpeakers() {
        let filter: any = {};
        if (!this.highlightedLoaded) {
            if (this.highlightedDataConfig.selectedList != null && this.highlightedDataConfig.selectedList.length > 0) {
                filter.section = this.sharedService.configTypes.SPEAKER.highlighted;
                filter.speakerIds = this.highlightedDataConfig.selectedList;
                this.speakerService.getSpeakersEs(filter).subscribe((resp) => {
                    this.highlightedLoaded = true;
                    if (resp.body != null && resp.body["speakers"].length > 0) {
                        var sortedSpeakers = [];
                        this.highlightedDataConfig.selectedList.forEach((id) => {
                            resp.body["speakers"].forEach((speaker) => {
                                if (speaker.id == id) {
                                    sortedSpeakers.push(speaker);
                                }
                            });
                        });

                        var idx = 0;
                        var datePipe = this.datePipe;
                        this.speakerList = {
                            speakers: sortedSpeakers,
                            idx: function() {
                                return idx++;
                            },
                            resetIndex: function() {
                                idx -= 1;
                                return;
                            },
                            index: function() {
                                return idx;
                            },
                            formatDobDate: function() {
                                return function(date, render) {
                                    return datePipe.transform(
                                        render(date).replace(new RegExp(" ", "g"), "T"),
                                        "dd-MMM-yyyy"
                                    );
                                };
                            }
                        };
                        this.highlightedStyle = this.createStyleString2(
                            this.highlightedSpeakerConfig["catalogConfig"].header
                        );

                        //For biography popup
                        this.highlightedSpeakerConfig["catalogConfig"].body = this.generalSpeakerConfig[
                            "catalogConfig"
                        ].body;
                        this.bioLayout = this.generalSpeakerConfig["layout"];

                        this.listemplateHelper(
                            this.highlightedSpeakerConfig,
                            this.highlightedList,
                            this.highlightedListRef,
                            "highlighted",
                            this.highlightedDataConfig.displayAs
                        );
                    } else {
                        this.noHighLightedSpeakers = true;
                    }
                    if (this.userPreferenceCookie != null) {
                        this.showHighlighted = this.userPreferenceCookie.showHighlighted;
                    }
                });
            } else {
                this.noHighLightedSpeakers = true;
            }
        }
    }

    getSpeakerList() {
        this.sharedService.generalListLoading = true;
        this.speakerList = {speakers: []};
        this.loadingList = true;
        let filter = {};

        this.filters.limit = 20;
        this.filters.section = this.sharedService.configTypes.SPEAKER.general;
        this.filters.page = this.esPage;
        if (this.esPage == 0) {
            this.nospeakersAvailable = false;
        }

        if (this.generalDataConfig.hasOwnProperty("defaultFilters")) {
            if (this.generalDataConfig.defaultFilters.speakerTypes.length > 0) {
                if (!this.filters.hasOwnProperty("speakerTypeIds")) {
                    this.filters["speakerTypeIds"] = [];
                }
                if (this.filters["speakerTypeIds"].length == 0) {
                    this.generalDataConfig.defaultFilters.speakerTypes.forEach((speakerType) => {
                        if (this.filters.speakerTypeIds.indexOf(speakerType.id) === -1) {
                            this.filters.speakerTypeIds.push(speakerType.id);
                        }
                    });
                }
            }
        }

        if (!this.sessionFilter.query) {
            delete this.filters["textQuery"];
        } else {
            this.filters["textQuery"] = this.sessionFilter.query;
        }

        filter = this.filters;

        this.speakerService.getSpeakersEs(filter).subscribe(
            (resp) => {
                if (resp.body != null) {
                    if (resp.body["speakers"].length == 0 && !this.filterResults) {
                        this.noSpeakersInCatalog = true;
                    } else if (resp.body["speakers"].length == 0 && this.filterResults) {
                        this.nospeakersAvailable = true;
                    } else if (resp.body["speakers"].length > 0) {
                        this.esPage = this.esPage + 1;
                        this.generalSpeakerConfig = JSON.parse(
                            this.sharedService.configs[this.sharedService.configTypes.SPEAKER.general].config
                        );
                    }
                    var idx = 0;
                    this.speakerList = {
                        speakers: resp.body["speakers"],
                        idx: function() {
                            return idx++;
                        },
                        resetIndex: function() {
                            idx -= 1;
                            return;
                        },
                        index: function() {
                            return idx;
                        }
                    };
                    if (
                        this.generalDataConfig.topLevel.groupingBy != null &&
                        this.generalDataConfig.topLevel.groupingBy != ""
                    ) {
                        this.groupingSpeaker();
                    } else {
                        if (this.generalList != null && this.clearGeneralSessionList) {
                            this.generalList.clear();
                            this.clearGeneralSessionList = false;
                        }
                        this.listemplateHelper(
                            this.generalSpeakerConfig,
                            this.generalList,
                            this.generalListRef,
                            "noGrouping-general",
                            ""
                        );
                    }
                    if (this.generalList != null && this.clearGeneralSessionList) {
                        this.generalList.clear();
                        this.clearGeneralSessionList = false;
                    }
                }
            },
            (err) => {
                this.sharedService.showLoader = true;
                this.loadingList = false;
                this.sharedService.generalListLoading = false;
            }
        );
        this.showCarousel = true;
    }

    openLoginPopup(item) {
        let url = "";
        if (item == "login") {
            this.popupService.setPosition("center");
            this.popupService.setSize("small");
            this.popupService.togglePopup();
            this.sharedService.currentPopup = {
                title: null,
                navLinks: null,
                saveMessage: "reg-login",
                showFooter: false
            };
            url = "popup/login";
        }
        this.sharedService.navigateToOutlet("popup", url);
    }

    previewAttendeeSide(list) {
        if (!this.fromAttendee) {
            this.generalDataConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
            );
        }

        if (list != null) {
            var idx = 0;
            this.speakerList = {
                speakers: list,
                idx: function() {
                    return idx++;
                },
                resetIndex: function() {
                    idx -= 1;
                    return;
                },
                index: function() {
                    return idx;
                }
            };
            if (!this.fromAttendee) {
                this.generalSpeakerConfig = JSON.parse(
                    this.sharedService.configs[this.sharedService.configTypes.SPEAKER.general].config
                );
            }

            if (
                this.generalDataConfig.topLevel.groupingBy != null &&
                this.generalDataConfig.topLevel.groupingBy != ""
            ) {
                this.groupingSpeaker();
            } else {
                if (this.generalList != null) {
                    this.generalList.clear();
                }
                this.listemplateHelper(
                    this.generalSpeakerConfig,
                    this.generalList,
                    this.generalListRef,
                    "noGrouping-general",
                    ""
                );
            }
        }
    }

    ngOnInit() {
        var customTags = ["{@ddf.", "@}"];
        const htmlScriptElement = document.createElement('script');
        htmlScriptElement.src = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js';
        this.elementRef.nativeElement.appendChild(htmlScriptElement);
        this.mustache.tags = customTags;
        this.generalDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
        );
        this.getHighlightedAndPromotedSpeakers();
        this.getLoggedInAttendee();
    }

    getSessionRegisteredLabel(param, sessionConfig) {
        let padding = sessionConfig.regionConfig.padding;
        let top = "-10px";
        let right = "-10px";
        if (padding != null) {
            let paddings = padding.split(" ");
            if (paddings.length == 1) {
                top = "-" + paddings[0];
                right = "-" + paddings[0];
            } else if (paddings.length == 2 || paddings.length == 4) {
                top = "-" + paddings[0];
                right = "-" + paddings[1];
            }
        }
        let style =
            "'position':'absolute', 'border': '10px solid " +
            sessionConfig.regionConfig.background +
            "', 'border-radius': '20px', 'top' : '" +
            top +
            "', 'right' : '" +
            right +
            "', ";
        let temp =
            '<span *ngIf="isEnrolled[{@ddf.index@}]"><div [ngStyle]="{ ' +
            style +
            " 'cursor': 'default','float': 'right','background': (+registrationSessionStatusId[{@ddf.index@}] == 1 || +registrationSessionStatusId[{@ddf.index@}] == 4 ? '" +
            param["buttonConfig"].regBackground +
            "' : '#9B9B9B'),'padding': '4px 20px','font-size': '" +
            param["buttonConfig"].regFontSize +
            "px','color': '" +
            param["buttonConfig"].regColor +
            "','text-decoration': '" +
            param["buttonConfig"].regFontStyle +
            "','font-weight': '" +
            param["buttonConfig"].regFontStyle +
            "','font-style': '" +
            param["buttonConfig"].regFontStyle +
            "'}\" ><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 1'>" +
            param["buttonConfig"].regLabel +
            "</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 2'>Cancelled</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 3'>No Show</span><span *ngIf='registrationSessionStatusId[{@ddf.index@}] == 4'>Attended</span></div></span>";
        return temp;
    }

    getSessionWaitlistedLabel(param, sessionConfig) {
        let padding = sessionConfig.regionConfig.padding;
        let top = "-10px";
        let right = "-10px";
        if (padding != null) {
            let paddings = padding.split(" ");
            if (paddings.length == 1) {
                top = "-" + paddings[0];
                right = "-" + paddings[0];
            } else if (paddings.length == 2 || paddings.length == 4) {
                top = "-" + paddings[0];
                right = "-" + paddings[1];
            }
        }
        let style =
            "position:absolute; border: 10px solid " +
            sessionConfig.regionConfig.background +
            "; border-radius: 20px; top : " +
            top +
            "; right : " +
            right +
            "; ";

        let temp =
            '<span *ngIf="isWaitListed[{@ddf.index@}]"><div style="' +
            style +
            "cursor: default;float: right;background: " +
            param["buttonConfig"].waitBackground +
            ";padding: 4px 20px;font-size: " +
            param["buttonConfig"].waitFontSize +
            "px;color: " +
            param["buttonConfig"].waitColor +
            ";text-decoration: " +
            param["buttonConfig"].waitFontStyle +
            ";font-weight: " +
            param["buttonConfig"].waitFontStyle +
            ";font-style: " +
            param["buttonConfig"].waitFontStyle +
            ';">' +
            param["buttonConfig"].waitLabel +
            "</div></span>";
        return temp;
    }

    listemplateHelper(speakerConfig, list, listRef, type, displayAs) {
        let param: any = {};
        this.param = param;
        param["headerTemplate"] = this.getSafeHtmlDescStr(speakerConfig.catalogConfig.header.textConfig.template);

        param["bodyTemplate"] = this.getSafeHtmlDescStr(speakerConfig.catalogConfig.body.textConfig.template);

        param["bodyTemplate"] = this.customFieldFileSpeakerDownloadHelper(param["bodyTemplate"]);

        param["headerTemplate"] = this.customFieldFileOnSpeakerListDownloadHelper(param["headerTemplate"]);

        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.customFieldMap.", "g"),
            "{@ddf.&customFieldMap."
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.customFieldMap.", "g"),
            "{@ddf.&customFieldMap."
        );

        if (type != "highlighted") {
            param["class"] = "general-speaker";
            param["bioLayout"] = speakerConfig.layout;
        } else {
            param["bioLayout"] = this.bioLayout;
            param["class"] = "highlighted-speaker";
        }
        if (param["bioLayout"] === "l_banner") {
            param["bodyBanner"] = speakerConfig.catalogConfig.body.imageConfig.banner;
        }

        param["headerStyleStr"] = this.createStyleString(speakerConfig.catalogConfig.header);

        param["headerTextStyleStr"] = this.createTextStyle(
            speakerConfig.catalogConfig.header,
            speakerConfig.catalogConfig.header.imageConfig.width,
            speakerConfig.layout
        );

        param["bodyStyleStr"] = this.createStyleString(speakerConfig.catalogConfig.body);

        param["bodyTextStyleStr"] = this.createTextStyle(
            speakerConfig.catalogConfig.body,
            speakerConfig.catalogConfig.body.imageConfig.width,
            speakerConfig.layout
        );

        param["headerImgStyle"] = this.createImageStyle(speakerConfig.catalogConfig.header, speakerConfig.layout);

        param["bodyImgStyle"] = this.createImageStyle(speakerConfig.catalogConfig.body, speakerConfig.layout);

        param["headerImgBasedOn"] = speakerConfig.catalogConfig.header.imageConfig.basedOn;

        param["bodyImgBasedOn"] = speakerConfig.catalogConfig.body.imageConfig.basedOn;

        param["layout"] = speakerConfig.layout;

        param["type"] = type + "-";

        param["modalService"] = this.ngxSmartModalService;

        param["attendeeSessionService"] = this.attendeeSessionService;

        param["speakerSessionStyleStr"] = this.createStyleString(this.speakerSessionConfig.catalogConfig.body);

        param["speakerSessionImgStyle"] = this.createImageStyle(
            this.speakerSessionConfig.catalogConfig.body,
            this.speakerSessionConfig.layout
        );

        param["speakerImgBasedOn"] = this.speakerSessionConfig.catalogConfig.body.imageConfig.basedOn;

        param["speakerSessionTextStyleStr"] = this.createTextStyle(
            this.speakerSessionConfig.catalogConfig.body,
            this.speakerSessionConfig.catalogConfig.body.imageConfig.width,
            this.speakerSessionConfig.layout
        );

        param["speakerSessionTemplate"] = this.speakerSessionConfig.catalogConfig.body.textConfig.template;
        param["speakerSessionTemplate"] = this.customFieldFileSpeakerDownloadHelper(param["speakerSessionTemplate"]);

        param["speakerSessionTemplate"] = this.getSafeHtmlDescStr(param["speakerSessionTemplate"]);
        param["speakerSessionLayout"] = this.speakerSessionConfig.layout;

        param["speakerModalHeader"] =
            "<div style='color:" +
            this.speakerSessionConfig.labelConfig.fontColor +
            ";text-decoration:" +
            this.speakerSessionConfig.labelConfig.fontStyle +
            ";font-weight:" +
            this.speakerSessionConfig.labelConfig.fontStyle +
            ";font-style:" +
            this.speakerSessionConfig.labelConfig.fontStyle +
            ";margin:" +
            this.speakerSessionConfig.catalogConfig.body.regionConfig.margin +
            ";padding:" +
            this.speakerSessionConfig.catalogConfig.body.regionConfig.padding +
            ";font-size:" +
            this.speakerSessionConfig.labelConfig.fontSize +
            "px;'>" +
            this.speakerSessionConfig.labelConfig.label +
            "</div>";

        if (speakerConfig.layout === "l_banner") {
            param["headerBanner"] = speakerConfig.catalogConfig.header.imageConfig.banner;
        }

        if (speakerConfig.catalogConfig.header.imageConfig.basedOn === "dynamic_img") {
            param["headerDynamicImg"] = speakerConfig.catalogConfig.header.imageConfig.dynamicImage;
        }

        if (speakerConfig.catalogConfig.body.imageConfig.basedOn === "dynamic_img") {
            param["bodyDynamicImg"] = speakerConfig.catalogConfig.body.imageConfig.dynamicImage;
        }

        if (this.speakerSessionConfig.layout === "l_banner") {
            param["speakerSessionBanner"] = this.speakerSessionConfig.catalogConfig.body.imageConfig.banner;
        }

        if (this.speakerSessionConfig.catalogConfig.body.imageConfig.basedOn === "dynamic_img") {
            param["speakerDynamicImg"] = this.speakerSessionConfig.catalogConfig.body.imageConfig.dynamicImage;
        }

        //For abstract file download
        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.abstractFile@}",
            '<span>{@ddf.#documents@}<span title="Download Abstract" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\' *ngIf="\'{@ddf.type@}\' === \'Abstract\'">{@ddf.name@} </span>{@ddf./documents@}</span>'
        );

        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.abstractFile@}",
            '<span>{@ddf.#documents@}<span title="Download Abstract" (cclClick)=\'downloadSessionDocument($event,"{@ddf.eventId@}", "{@ddf.name@}", "{@ddf.type@}", "{@ddf.sessionId@}")\' *ngIf="\'{@ddf.type@}\' === \'Abstract\'">{@ddf.name@} </span>{@ddf./documents@}</span>'
        );

        //For presentation files download

        param["speakerSessionTemplate"] = param["speakerSessionTemplate"].replace(
            new RegExp("{@ddf.presentations@}", "g"),
            '{@ddf.#documents@}<span class="sessionFiles cursor-pointer" data-filename="' +
                "{@ddf.name@}" +
                '" data-documentType="{@ddf.type@}" data-eventId="' +
                "{@ddf.eventId@}" +
                '" data-sessionId="{@ddf.sessionId@}">{@ddf.#presentations@}{@ddf.type@}{@ddf@}{@ddf.name@}{@ddf./presentations@} ' +
                "</span>{@ddf./documents@}"
        );

        param["speakerSessionTemplate"] = this.sessionCustomFieldFileDownloadHelper(param["speakerSessionTemplate"]);

        param["speakerSessionTemplate"] = param["speakerSessionTemplate"].replace(
            new RegExp("{@ddf.tags@}", "g"),
            '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
        );

        param["speakerSessionTemplate"] = param["speakerSessionTemplate"].replace(
            new RegExp("{@ddf.speakerList@}", "g"),
            '<span class="speakerContainer">{@ddf.#speakers@}<span class="speakerItem">{@ddf.speakerFirstName@} {@ddf.speakerLastName@}</span>{@ddf./speakers@}</span>'
        );

        //for Session Fee or Session cancellation Fee in speakerSessionTemplate
        this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace("{@ddf.currentFee@}", this.defaultCurrencySymbol + ' {@ddf.currentFee@}');

        this.param["speakerSessionTemplate"] = this.param["speakerSessionTemplate"].replace("{@ddf.currentCancellationFee@}", this.defaultCurrencySymbol + ' {@ddf.currentCancellationFee@}');

        // Replace Session Industrys and JobFunctions DDF values
        param["speakerSessionTemplate"] = param["speakerSessionTemplate"].replace(
            new RegExp("{@ddf.confIndustrys@}", "g"),
            '<span class="industrysContainer">{@ddf.#confIndustrys@}<span>{@ddf.name@}</span>{@ddf./confIndustrys@}</span>'
        );

        param["speakerSessionTemplate"] = param["speakerSessionTemplate"].replace(
            new RegExp("{@ddf.confJobFunctions@}", "g"),
            '<span class="jobFunctionsContainer">{@ddf.#confJobFunctions@}<span>{@ddf.name@}</span>{@ddf./confJobFunctions@}</span>'
        );

        //For showing other instances
        param["headerTemplate"] = param["headerTemplate"].replace(
            "{@ddf.allInstances@}",
            '<span *ngIf=\'"{@ddf.statusId@}" == 6\' title="Show Available Times" (cclClick)=\'showAllInstances($event,"{@ddf.sessionId@}", "{@ddf.id@}")\'>Show other schedules</span>'
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            "{@ddf.allInstances@}",
            '<span *ngIf=\'"{@ddf.statusId@}" == 6\' title="Show Available Times" (cclClick)=\'showAllInstances($event,"{@ddf.sessionId@}", "{@ddf.id@}")\'>Show other schedules</span>'
        );

        //For Displaying Session fees with currency symbol
        param["headerTemplate"] = param["headerTemplate"].replace("{@ddf.currentFee@}", this.defaultCurrencySymbol + ' {@ddf.currentFee@}');
        param["headerTemplate"] = param["headerTemplate"].replace("{@ddf.currentCancellationFee@}", this.defaultCurrencySymbol + ' {@ddf.currentCancellationFee@}');

        param["bodyTemplate"] = param["bodyTemplate"].replace("{@ddf.currentFee@}", this.defaultCurrencySymbol + ' {@ddf.currentFee@}');
        param["bodyTemplate"] = param["bodyTemplate"].replace("{@ddf.currentCancellationFee@}", this.defaultCurrencySymbol + ' {@ddf.currentCancellationFee@}');

        //for tags array
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.tags@}", "g"),
            '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.tags@}", "g"),
            '<span class="tagsContainer">{@ddf.#tags@}<span>{@ddf.name@}</span>{@ddf./tags@}</span>'
        );

        // Replace Session Industries and JobFunctions DDF values
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.confIndustrys@}", "g"),
            '<span class="industrysContainer">{@ddf.#confIndustrys@}<span>{@ddf.name@}</span>{@ddf./confIndustrys@}</span>'
        );
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.confJobFunctions@}", "g"),
            '<span class="jobFunctionsContainer">{@ddf.#confJobFunctions@}<span>{@ddf.name@}</span>{@ddf./confJobFunctions@}</span>'
        );


        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.confIndustrys@}", "g"),
            '<span class="industrysContainer">{@ddf.#confIndustrys@}<span>{@ddf.name@}</span>{@ddf./confIndustrys@}</span>'
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.confJobFunctions@}", "g"),
            '<span class="jobFunctionsContainer">{@ddf.#confJobFunctions@}<span>{@ddf.name@}</span>{@ddf./confJobFunctions@}</span>'
        );

        //For showing Speaker's DOB
        param["headerTemplate"] = param["headerTemplate"].replace(
            new RegExp("{@ddf.speakerDob@}", "g"),
            "{@ddf.#formatDobDate@}{@ddf.speakerDob@}{@ddf./formatDobDate@}"
        );
        param["bodyTemplate"] = param["bodyTemplate"].replace(
            new RegExp("{@ddf.speakerDob@}", "g"),
            "{@ddf.#formatDobDate@}{@ddf.speakerDob@}{@ddf./formatDobDate@}"
        );

        param["attendeeSessionService"] = this.attendeeSessionService;
        param["datePipe"] = this.datePipe;

        param["notifyService"] = this.notifyService;

        param["_flashMessagesService"] = this._flashMessagesService;
        param["speakerService"] = this.speakerService;

        if (type === "general") {
            param["sharedService"] = this.sharedService;
            if (this.isLoggedIn) {
                param["buttonConfig"] = speakerConfig.catalogConfig.buttonConfig;
                if (param["buttonConfig"] != undefined) {
                    if (param["buttonConfig"].regLabel == undefined || param["buttonConfig"].regLabel == "") {
                        param["buttonConfig"].regLabel = "Registered";
                    }
                    if (param["buttonConfig"].waitLabel == undefined || param["buttonConfig"].waitLabel == "") {
                        param["buttonConfig"]["waitLabel"] = "Waitlisted";
                    }
                    if (
                        param["buttonConfig"].cartButtonLabel == undefined ||
                        param["buttonConfig"].cartButtonLabel == ""
                    ) {
                        param["buttonConfig"]["cartButtonLabel"] = "Add to cart";
                    }
                    if (
                        param["buttonConfig"].fillingFastLabel == undefined ||
                        param["buttonConfig"].fillingFastLabel == ""
                    ) {
                        param["buttonConfig"]["fillingFastLabel"] = "Filling Fast";
                    }
                    if (
                        param["buttonConfig"].fillingFastPercent == undefined ||
                        param["buttonConfig"].fillingFastPercent == ""
                    ) {
                        param["buttonConfig"]["fillingFastPercent"] = "10";
                    }
                    if (!param["buttonConfig"].hasOwnProperty("enableAddToCartButton")) {
                        param["buttonConfig"]["enableAddToCartButton"] = true;
                    }
                    if (
                        param["buttonConfig"].capacityFullLabel == undefined ||
                        param["buttonConfig"].capacityFullLabel == ""
                    ) {
                        param["buttonConfig"]["capacityFullLabel"] = "Session capacity is full";
                    }
                }
                // for footer on header
                param["headerTemplate"] =
                    param["headerTemplate"] +
                    '<div *ngIf="{@ddf.break@}" class="row"><div *ngIf=\'showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]\'><div style="position: absolute;top: 0;right: 0px;" *ngIf=\'addToFavourite[{@ddf.index@}]\'><i title="Add Session to Favorites" (cclClick)=\'addSessionToFavourite($event,{@ddf.index@},"{@ddf.id@}")\' style="font-size: ' +
                    param["buttonConfig"].favIconSize +
                    "px;color: " +
                    param["buttonConfig"].favIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].favIconSec +
                    ' pull-right"></i></div><div style="position: absolute;top: 0;right: 30px;" *ngIf=\'addToFavourite[{@ddf.index@}]\'><i title="Hide Session" (cclClick)=\'excludeSession($event,{@ddf.index@},"{@ddf.id@}")\' style="font-size: ' +
                    param["buttonConfig"].excIconSize +
                    "px;color: " +
                    param["buttonConfig"].excIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].excIcon +
                    ' pull-right"></i></div><div style="position: absolute;top: 0;right: 0;" *ngIf=\'!addToFavourite[{@ddf.index@}]\'><i title="Remove Session from Favorites" (cclClick)=\'removeSessionFromFavourite($event,{@ddf.index@},"{@ddf.id@}")\' style="font-size: ' +
                    param["buttonConfig"].favIconSize +
                    "px;color: " +
                    param["buttonConfig"].favIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].favIcon +
                    ' pull-right"></i></div></div><div style="position: absolute;top: 0;right: 0px;padding-right: 0px;" *ngIf="!showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    ' && !isWaitListed[{@ddf.index@}];else flags" class="col-12"><i title="In Cart" style="font-size: ' +
                    param["buttonConfig"].cartIconSize +
                    "px;color: " +
                    param["buttonConfig"].cartIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].cartIcon +
                    ' pull-right"></i></div><ng-template #flags><div style="position: absolute;top: 0;right: 0px;padding-right: 0px;" class="col-12">' +
                    this.getSessionRegisteredLabel(param, speakerConfig.catalogConfig.header) +
                    this.getSessionWaitlistedLabel(param, speakerConfig.catalogConfig.header) +
                    "</div></ng-template></div>";

                // for footer on body
                param["bodyTemplate"] =
                    param["bodyTemplate"] +
                    '<div *ngIf="{@ddf.break@}" class="row" style="padding: 10px 0px 20px 0px;margin: 0px;"><hr style="height:1px;border-width:0;color:gray;background-color:gray;width: 100%;text-align: justify;margin-left: 0px;"><div *ngIf="false"><div class="col-sm-2" style="font-size: 20px;line-height: 30px;font-weight: bold;padding-left: 0px;">Currently Registered</div><div class="col-sm-1" style="font-size: 40px;line-height: 50px;font-weight: bold;padding: 0px;">{@ddf.registered@}</div><div class="col-sm-1" style="font-size: 20px;line-height: 30px;font-weight: bold;">Open</div><div class="col-sm-2" style="font-size: 40px;line-height: 50px;font-weight: bold;">{@ddf.remaining@}</div></div><div *ngIf="!isEnrolled[{@ddf.index@}]" class="col-sm-6" style="font-size: 18px;color: ' +
                    param["buttonConfig"].fillingFastColor +
                    ";text-decoration: " +
                    param["buttonConfig"].fillingFastFontStyle +
                    ";font-weight: " +
                    param["buttonConfig"].fillingFastFontStyle +
                    ";font-style: " +
                    param["buttonConfig"].fillingFastFontStyle +
                    ';">{@ddf.#remainingPercentage@}{@ddf.break@}{"capacity":"{@ddf.capacity@}","remaining":"{@ddf.remaining@}"}{@ddf./remainingPercentage@}</div><div class="col-sm-6 col--builder" *ngIf=\'' +
                    !param["buttonConfig"].enableAddToCartButton +
                    ' && showButton[{@ddf.index@}]\'><div *ngIf="!isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]" title="Add to Schedule" (cclClick)=\'registerSession($event,"{@ddf.id@}",{@ddf.index@},addToFavourite[{@ddf.index@}])\'><div style="float: right;background: ' +
                    param["buttonConfig"].cartButtonBackground +
                    ";padding: 8px;border-radius: 15px 0px 0px 0px;font-size: 20px;color: " +
                    param["buttonConfig"].cartButtonColor +
                    ";text-decoration: " +
                    param["buttonConfig"].cartButtonStyle +
                    ";font-weight: " +
                    param["buttonConfig"].cartButtonStyle +
                    ";font-style: " +
                    param["buttonConfig"].cartButtonStyle +
                    ';"><i title="Processing" class="fa fa-spinner fa-spin" *ngIf="!isNotProcessingSession[{@ddf.index@}]"></i><span *ngIf="!isNotProcessingSession[{@ddf.index@}]">&nbsp;</span><span *ngIf=\'!isGoingToBeWaitlisted[{@ddf.index@}];else waitlist\'>Add to Schedule</span><ng-template #waitlist><span>Add to Waitlist</span></ng-template></div></div></div><div class="col-sm-6 col--builder" *ngIf="!showButton[{@ddf.index@}]"><div style="text-align: right;font-size: 18px;color: ' +
                    param["buttonConfig"].capacityFullColor +
                    ";text-decoration: " +
                    param["buttonConfig"].capacityFullFontStyle +
                    ";font-weight: " +
                    param["buttonConfig"].capacityFullFontStyle +
                    ";font-style: " +
                    param["buttonConfig"].capacityFullFontStyle +
                    ';">' +
                    param["buttonConfig"].capacityFullLabel +
                    '</div></div><div class="col-sm-6 col--builder" *ngIf=\'showAddToCart[{@ddf.index@}] && showButton[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    '\'><div *ngIf="!isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]" title="Add Session to Cart" (cclClick)=\'addSessionToCart($event,"{@ddf.id@}",{@ddf.index@},addToFavourite[{@ddf.index@}])\'><div style="float: right;background: ' +
                    param["buttonConfig"].cartButtonBackground +
                    ";padding: 8px;border-radius: 15px 0px 0px 0px;font-size: 18px;color: " +
                    param["buttonConfig"].cartButtonColor +
                    ";text-decoration: " +
                    param["buttonConfig"].cartButtonStyle +
                    ";font-weight: " +
                    param["buttonConfig"].cartButtonStyle +
                    ";font-style: " +
                    param["buttonConfig"].cartButtonStyle +
                    ";\"><i title='Processing' class='fa fa-spinner fa-spin' *ngIf='!isNotProcessingSession[{@ddf.index@}]'></i><span *ngIf='!isNotProcessingSession[{@ddf.index@}]'>&nbsp;</span><span>" +
                    param["buttonConfig"].cartButtonLabel +
                    "</span></div></div></div><div *ngIf='showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && !isWaitListed[{@ddf.index@}]'><div style=\"position: absolute;top: 0;right: 0;\" *ngIf='addToFavourite[{@ddf.index@}]'><i title='Add Session to Favorites' (cclClick)='addSessionToFavourite($event,{@ddf.index@},\"{@ddf.id@}\")' style=\"font-size: " +
                    param["buttonConfig"].favIconSize +
                    "px;color: " +
                    param["buttonConfig"].favIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].favIconSec +
                    ' pull-right"></i></div><div style="position: absolute;top: 0;right: 0;" *ngIf=\'!addToFavourite[{@ddf.index@}]\'><i title="Remove Session from Favorites" (cclClick)=\'removeSessionFromFavourite($event,{@ddf.index@},"{@ddf.id@}")\' style="font-size: ' +
                    param["buttonConfig"].favIconSize +
                    "px;color: " +
                    param["buttonConfig"].favIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].favIcon +
                    ' pull-right"></i></div></div><div style="position: absolute;top: 0;right: 0px;padding-right: 0px;" *ngIf="!showAddToCart[{@ddf.index@}] && !isEnrolled[{@ddf.index@}] && ' +
                    param["buttonConfig"].enableAddToCartButton +
                    ' && !isWaitListed[{@ddf.index@}];else flags" class="col-12"><i title="In Cart" style="font-size: ' +
                    param["buttonConfig"].cartIconSize +
                    "px;color: " +
                    param["buttonConfig"].cartIconColor +
                    ';" class="fa ' +
                    param["buttonConfig"].cartIcon +
                    ' pull-right"></i></div><ng-template #flags><div style="position: absolute;top: 0;right: 0px;padding-right: 0px;" class="col-12">' +
                    this.getSessionRegisteredLabel(param, speakerConfig.catalogConfig.body) +
                    this.getSessionWaitlistedLabel(param, speakerConfig.catalogConfig.body) +
                    "</div></ng-template></div>";

                param["loggedInAttendee"] = this.sharedService.loggedInAttendee;
            }

            var toggle = [];
            var favFlag = [];
            var showAddToCart = [];
            var sessionData = [];
            var isEnrolled = [];
            var isWaitListed = [];
            var isGoingToBeWaitlisted = [];
            var showButton = [];
            var instanceId = [];
            var registrationSessionStatusId = [];
            for (let i = 0; i < this.speakerArrangedList.speakers.length; ++i) {
                toggle.push(true);
                if (this.isLoggedIn) {
                    if (this.speakerArrangedList.speakers[i].break) {
                        instanceId.push(this.speakerArrangedList.speakers[i].id);
                        favFlag.push(!this.speakerArrangedList.speakers[i].isFavouriteSession);
                        showAddToCart.push(!this.speakerArrangedList.speakers[i].isAddedToCart);
                        isEnrolled.push(this.speakerArrangedList.speakers[i].isEnrolled);
                        isWaitListed.push(this.speakerArrangedList.speakers[i].isWaitListed);
                        registrationSessionStatusId.push(
                            this.speakerArrangedList.speakers[i].registrationSessionStatusId
                        );
                        if (
                            this.speakerArrangedList.speakers[i].isVacancy ||
                            this.speakerArrangedList.speakers[i].remaining > 0
                        ) {
                            isGoingToBeWaitlisted.push(false);
                            showButton.push(true);
                        } else if (
                            this.speakerArrangedList.speakers[i].waitlistedLimit == null ||
                            this.speakerArrangedList.speakers[i].waitlistedLimit >
                                this.speakerArrangedList.speakers[i].waitlisted
                        ) {
                            isGoingToBeWaitlisted.push(true);
                            showButton.push(true);
                        } else {
                            isGoingToBeWaitlisted.push(false);
                            showButton.push(false);
                        }
                    } else {
                        favFlag.push(true);
                        showAddToCart.push(true);
                        isEnrolled.push(false);
                        isWaitListed.push(false);
                        isGoingToBeWaitlisted.push(false);
                        showButton.push(false);
                        instanceId.push("");
                        registrationSessionStatusId.push("");
                    }
                    sessionData.push(this.speakerArrangedList.speakers[i].break);
                }
            }

            if (this.esPage > 1) {
                this.currentGroupingLevels = { topLevel: "" };
                for (let i = 0; i < this.speakerArrangedList.speakers.length; ++i) {
                    if (
                        this.speakerArrangedList.speakers[i].level == "top" &&
                        this.currentGroupingLevels.topLevel === ""
                    ) {
                        this.currentGroupingLevels.topLevel = this.speakerArrangedList.speakers[i].groupProperty;
                        if (this.prevGroupingLevels.topLevel === this.currentGroupingLevels.topLevel) {
                            toggle[i] = false;
                        }
                    }
                }
            }
            this.prevGroupingLevels = { topLevel: "" };
            for (let i = this.speakerArrangedList.speakers.length - 1; i >= 0; --i) {
                if (!this.speakerArrangedList.speakers[i].break) {
                    if (
                        this.speakerArrangedList.speakers[i].level == "top" &&
                        this.prevGroupingLevels.topLevel === ""
                    ) {
                        this.prevGroupingLevels.topLevel = this.speakerArrangedList.speakers[i].groupProperty;
                    }
                }
            }
            sessionData.push(false);
            toggle.push(false);
            param["toggle"] = toggle;
            param["favFlag"] = favFlag;
            param["showAddToCart"] = showAddToCart;
            param["sessionData"] = sessionData;
            param["isEnrolled"] = isEnrolled;
            param["isWaitListed"] = isWaitListed;
            param["isGoingToBeWaitlisted"] = isGoingToBeWaitlisted;
            param["showButton"] = showButton;
            param["instanceId"] = instanceId;
            param["registrationSessionStatusId"] = registrationSessionStatusId;

            if (this.sharedService.catalogLayoutConfig.listType == "card") {
                this.output = this.mustache.render(
                    "<div class='row row--builder'>{@ddf.#speakers@}<div title='View Speaker' (cclClick)=\"openModel($event,'{@ddf.speakerId@}', '" +
                        this.sharedService.eventUUID +
                        "' ,{@ddf.index@})\" *ngIf='{@ddf.break@}' " +
                        "class='speaker-card " +
                        `${param["class"]}-catalog-header-region` +
                        "' >" +
                        "<div *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-speaker-list-img-container ' +
                        `${param["class"]}-catalog-header-container` +
                        '"><img alt="Speaker Image" class="img-fluid ' +
                        `${param["class"]}-catalog-header-img" ` +
                        "[src]=\"'dynamic_img'!='" +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.profilePicURL@}'.length > 0 ?'{@ddf.profilePicURL@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        "'\"></div>" +
                        //Add banner image with header layout SCM-41562
                        "<div *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" class='width-99 ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\" src=\"" +
                        param["headerBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"></div>' +
                        "<div class='speaker-info-container " +
                        `${param["class"]}-header-text-style ` +
                        `${param["class"]}-header-text-style-no-image-or-banner-or-card'` +
                        ">" +
                        param["headerTemplate"] +
                        "</div></div><div class='minw-100' *ngIf='!{@ddf.break@} && isNotExcluded[{@ddf.index@}]'><label class='{@ddf.level@} {@ddf.styleStr@}'>{@ddf.groupProperty@}</label></div><p hidden>{@ddf.idx@}</p>{@ddf./speakers@}</div>",
                    this.speakerArrangedList
                );
            } else {
                this.output = this.mustache.render(
                    '{@ddf.#speakers@}<div title="View Speaker" *ngIf="{@ddf.break@} && isNotExcluded[{@ddf.index@}]" ' +
                        "[ngClass]=\"{'cursor-pointer': true, " +
                        `'attendee-session-list-container': 'l_banner' != '${param["layout"]}', ` +
                        `'${param["class"]}-catalog-header-region': toggle[{@ddf.index@}], ` +
                        `'${param["class"]}-catalog-body-region': !toggle[{@ddf.index@}]` +
                        '}" id="' +
                        param["type"] +
                        "{@ddf.idx@}\" {@ddf.resetIndex@}  (cclClick)=\"openModel($event,'{@ddf.speakerId@}', '" +
                        this.sharedService.eventUUID +
                        "' ,{@ddf.idx@})\" {@ddf.resetIndex@}" +
                        ">" +
                        //header section
                        "<div *ngIf='toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container ' +
                        `${param["class"]}-catalog-header-container` +
                        '"><img alt="Speaker Image" class="img-fluid ' +
                        `${param["class"]}-catalog-header-img" ` +
                        "[src]=\"'dynamic_img'!='" +
                        param["headerImgBasedOn"] +
                        "'?('{@ddf.profilePicURL@}'.length > 0 ?'{@ddf.profilePicURL@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["headerDynamicImg"] +
                        "'\"></div>" +
                        "<div *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" class='width-99 ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["headerBanner"] +
                        "'!='undefined'\" src=\"" +
                        param["headerBanner"] +
                        '" class="' +
                        `${param["class"]}-catalog-header-img` +
                        '"></div>' +
                        "<div class='attendee-session-list-text-container' " +
                        `[ngClass]="['${param["class"]}-header-text-style',` +
                        (param["layout"] != "l_banner" && param["layout"] != "l_noimage"
                            ? `'${param["class"]}-header-text-style-image-no-banner-no-card']"`
                            : `'${param["class"]}-header-text-style-no-image-or-banner-or-card']"`) +
                        ">" +
                        param["headerTemplate"] +
                        "</div>" +
                        "</div></div>" +
                        //body section
                        "<div *ngIf='!toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                        "<div class='row'>" +
                        "<div *ngIf=\"!('l_noimage' === '" +
                        param["layout"] +
                        "' || 'l_banner' === '" +
                        param["layout"] +
                        '\')" class="attendee-session-list-img-container" style="' +
                        param["bodyImgStyle"]["div"] +
                        '"><img alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                        param["bodyImgBasedOn"] +
                        "'?('{@ddf.profilePicURL@}'.length > 0 ?'{@ddf.profilePicURL@}" +
                        "':'assets/images/blank_profile.jpg'):'" +
                        param["bodyDynamicImg"] +
                        '\'" style="' +
                        param["bodyImgStyle"]["img"] +
                        '"></div>' +
                        "<div *ngIf=\"'l_banner' === '" +
                        param["layout"] +
                        "'\" style='width: 99%;text-align: center;'><img alt=\"Banner Image\" *ngIf=\"'" +
                        param["bodyBanner"] +
                        "'!='undefined'\" src=\"" +
                        param["bodyBanner"] +
                        '" style="' +
                        param["bodyImgStyle"]["img"] +
                        '"> </div>' +
                        "<div class='attendee-session-list-text-container' " +
                        `[ngClass]="['${param["class"]}-body-text-style', '${param["class"]}-body-text-style-image-no-banner-no-card']"` +
                        ">" +
                        param["bodyTemplate"] +
                        "</div>" +
                        "</div></div>" +
                        '</div> <div *ngIf="!{@ddf.break@} && isNotExcluded[{@ddf.index@}]"><label class="{@ddf.level@} {@ddf.styleStr@}">{@ddf.groupProperty@}</label></div><p hidden>{@ddf.idx@}</p>{@ddf./speakers@}',
                    this.speakerArrangedList
                );
            }

            this.createComponentFromRaw(param, this.output, this.mustache, this.speakerArrangedList, list, listRef);
        } else {
            param["sharedService"] = this.sharedService;
            var toggle = [];
            for (let i = 0; i < this.speakerList["speakers"].length; ++i) {
                toggle.push(true);
            }
            param["toggle"] = toggle;
            if (this.sharedService.catalogLayoutConfig.vipUnit == "card" && type == "highlighted") {
                displayAs = "all_session";
            }
            if (displayAs != "1_carousel") {
                if (
                    (this.sharedService.catalogLayoutConfig.listType == "card" && type != "highlighted") ||
                    (this.sharedService.catalogLayoutConfig.vipUnit == "card" && type == "highlighted")
                ) {
                    this.output = this.mustache.render(
                        "<div class='row row--builder'>{@ddf.#speakers@}<div title='View Speaker' (cclClick)=\"openModel($event,'{@ddf.speakerId@}', '" +
                            this.sharedService.eventUUID +
                            "' ,{@ddf.index@})\" " +
                            "class='speaker-card " +
                            `${param["class"]}-catalog-header-region` +
                            "' >" +
                            "<div *ngIf=\"!('l_noimage' === '" +
                            param["layout"] +
                            "' || 'l_banner' === '" +
                            param["layout"] +
                            '\')" class="attendee-speaker-list-img-container ' +
                            `${param["class"]}-catalog-header-container` +
                            '"><img alt="Speaker Image" class="img-fluid ' +
                            `${param["class"]}-catalog-header-img` +
                            "\" [src]=\"'dynamic_img'!='" +
                            param["headerImgBasedOn"] +
                            "'?('{@ddf.profilePicURL@}'.length > 0 ?'{@ddf.profilePicURL@}" +
                            "':'assets/images/blank_profile.jpg'):'" +
                            param["headerDynamicImg"] +
                            "'\"></div>" +
                            //Add banner image with header layout SCM-41562
                            "<div *ngIf=\"'l_banner' === '" +
                            param["layout"] +
                            "'\" class='width-99 ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                            param["headerBanner"] +
                            "'!='undefined'\" src=\"" +
                            param["headerBanner"] +
                            '" class="' +
                            `${param["class"]}-catalog-header-img` +
                            '"> </div>' +
                            "<div class='speaker-info-container " +
                            `${param["class"]}-header-text-style ` +
                            `${param["class"]}-header-text-style-no-image-or-banner-or-card` +
                            "'>" +
                            param["headerTemplate"] +
                            "</div></div>{@ddf./speakers@}</div>",
                        this.speakerList
                    );
                } else {
                    this.output = this.mustache.render(
                        "{@ddf.#speakers@}<div title='View Speaker' " +
                            "[ngClass]=\"{'cursor-pointer': true, " +
                            `'attendee-session-list-container': 'l_banner' != '${param["layout"]}', ` +
                            `'${param["class"]}-catalog-header-region': toggle[{@ddf.index@}], ` +
                            `'${param["class"]}-catalog-body-region': !toggle[{@ddf.index@}]` +
                            '}" id="' +
                            param["type"] +
                            "{@ddf.idx@}\" {@ddf.resetIndex@} (cclClick)=\"openModel($event,'{@ddf.speakerId@}', '" +
                            this.sharedService.eventUUID +
                            "' ,{@ddf.idx@})\" {@ddf.resetIndex@}" +
                            ">" +
                            //header section
                            "<div *ngIf='toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                            "<div class='row'>" +
                            "<div *ngIf=\"!('l_noimage' === '" +
                            param["layout"] +
                            "' || 'l_banner' === '" +
                            param["layout"] +
                            '\')" class="attendee-session-list-img-container ' +
                            `${param["class"]}-catalog-header-container` +
                            '"><img alt="Speaker Image" class="img-fluid ' +
                            `${param["class"]}-catalog-header-img` +
                            "\"[src]=\"'dynamic_img'!='" +
                            param["headerImgBasedOn"] +
                            "'?('{@ddf.profilePicURL@}'.length > 0 ?'{@ddf.profilePicURL@}" +
                            "':'assets/images/blank_profile.jpg'):'" +
                            param["headerDynamicImg"] +
                            "'\"></div>" +
                            "<div *ngIf=\"'l_banner' === '" +
                            param["layout"] +
                            "'\" class='width-99 ta-center'><img alt=\"Banner Image\" *ngIf=\"'" +
                            param["headerBanner"] +
                            "'!='undefined'\" src=\"" +
                            param["headerBanner"] +
                            '" class="' +
                            `${param["class"]}-catalog-header-img` +
                            '"> </div>' +
                            "<div class='attendee-session-list-text-container " +
                            `${param["class"]}-header-text-style ` +
                            (param["layout"] != "l_banner" && param["layout"] != "l_noimage"
                                ? `${param["class"]}-header-text-style-image-no-banner-no-card`
                                : `${param["class"]}-header-text-style-no-image-or-banner-or-card`) +
                            "'>" +
                            param["headerTemplate"] +
                            "</div></div></div>" +
                            //body section
                            "<div *ngIf='!toggle[{@ddf.idx@}]' {@ddf.resetIndex@} class='col-sm-12'>" +
                            "<div class='row'>" +
                            "<div *ngIf=\"!('l_noimage' === '" +
                            param["layout"] +
                            "' || 'l_banner' === '" +
                            param["layout"] +
                            '\')" class="attendee-session-list-img-container" style="' +
                            param["bodyImgStyle"]["div"] +
                            '"><img alt="Speaker Image" class="img-fluid" [src]="\'dynamic_img\'!=\'' +
                            param["bodyImgBasedOn"] +
                            "'?('{@ddf.profilePicURL@}'.length > 0 ?'{@ddf.profilePicURL@}" +
                            "':'assets/images/blank_profile.jpg'):'" +
                            param["bodyDynamicImg"] +
                            '\'" style="' +
                            param["bodyImgStyle"]["img"] +
                            '"></div>' +
                            "<div *ngIf=\"'l_banner' === '" +
                            param["layout"] +
                            "'\" style='width: 99%;text-align: center;'><img alt=\"Banner Image\" *ngIf=\"'" +
                            param["bodyBanner"] +
                            "'!='undefined'\" src=\"" +
                            param["bodyBanner"] +
                            '" style="' +
                            param["bodyImgStyle"]["img"] +
                            '"> </div>' +
                            "<div class='attendee-session-list-text-container " +
                            `${param["class"]}-body-text-style ` +
                            `${param["class"]}-body-text-style-image-no-banner-no-card` +
                            "'>" +
                            param["bodyTemplate"] +
                            "</div>" +
                            "</div></div>" +
                            "</div><p hidden>{@ddf.idx@}</p>{@ddf./speakers@}",
                        this.speakerList
                    );
                }

                this.createComponentFromRaw(param, this.output, this.mustache, this.speakerList, list, listRef);
            } else {
                this.speakerList["speakers"].forEach((speaker) => {
                    this.slideRender(param, speaker, type);
                });
            }
        }
    }

    createTemplate(imgStyle, textStyleStr, output2, speaker, imageBasedOn, bannerImage, dynamicImage, param) {
        if (param["layout"] != "l_noimage" && param["layout"] != "l_banner") {
            let imagePath = "assets/images/blank_profile.jpg";
            if (imageBasedOn === "speaker_img" && speaker != undefined) {
                if (speaker.profilePicURL) {
                    imagePath = speaker.profilePicURL;
                }
            }
            if (imageBasedOn === "dynamic_img") {
                if (dynamicImage != "") {
                    imagePath = dynamicImage;
                }
            }
            return (
                '<div class="attendee-session-list-img-container ' +
                `${param["class"]}-catalog-header-container ` +
                "flex-unset" +
                '"><img alt="Speaker Image" class="' +
                `${param["class"]}-catalog-header-img` +
                '"src="' +
                imagePath +
                '"></div>' +
                "<div class='attendee-session-list-text-container " +
                `${param["class"]}-catalog-header-text` +
                "' {@ddf.resetIndex@}" +
                ">" +
                output2 +
                "</div>"
            );
        } else {
            return (
                (param["layout"] === "l_banner" && bannerImage != undefined
                    ? '<div><center><img alt="Banner Image" src="' +
                      bannerImage +
                      '" class="' +
                      `${param["class"]}-catalog-header-img` +
                      '"></center></div>'
                    : "") +
                "<div class='attendee-session-list-text-container " +
                `${param["class"]}-catalog-header-text` +
                "' {@ddf.resetIndex@} " +
                ">" +
                output2 +
                "</div>"
            );
        }
    }

    slideRender(param, speaker, type) {
        {
            param["headerStyleStr"] = param["headerStyleStr"].replace(/,/g, "; ");
            param["headerStyleStr"] = param["headerStyleStr"].replace(/[{}']/g, "");
            param["bodyStyleStr"] = param["bodyStyleStr"].replace(/,/g, "; ");
            param["bodyStyleStr"] = param["bodyStyleStr"].replace(/[{}']/g, "");
            param["headerTextStyleStr"] = param["headerTextStyleStr"].replace(/,/g, "; ");
            param["headerTextStyleStr"] = param["headerTextStyleStr"].replace(/[{}']/g, "");
            param["headerTemplate"] = param["headerTemplate"]
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");

            var output = mustache.render(
                this.createTemplate(
                    param["headerImgStyle"],
                    param["headerTextStyleStr"],
                    param["headerTemplate"],
                    speaker,
                    param["headerImgBasedOn"],
                    param["headerBanner"],
                    param["headerDynamicImg"],
                    param
                ),
                speaker
            );

            if (type === "promoted") {
                if (this.promotedHasSlide) {
                    this.promotedCarousel.push({ content: output });
                } else {
                    this.promotedCarousel[0].content = output;
                    this.promotedHasSlide = true;
                }
            } else {
                if (this.highlightedHasSlide) {
                    this.highlightedCarousel.push({ content: output });
                } else {
                    this.highlightedCarousel[0].content = output;
                    this.highlightedHasSlide = true;
                }
            }
        }
    }

    reduceHelper(array, filter) {
        return array.reduce((map, obj) => {
            if (Object.keys(map).length === 0 && map.constructor === Object) {
                map = new Map();
            }

            let subEl = obj[filter];
            if(!subEl) {
                let temp = obj.customFieldMap ? obj.customFieldMap[filter] || '' : '';
                if(temp) {
                    let filterObj =  this.sharedService.speakerEnumCustomFields.find(element => element.code == filter)
                    subEl = filterObj.options.find(ele => ele.code.toLowerCase() == temp.toLowerCase())?.name || null
                } else {
                    subEl = null;  
                }
            }

            if (!subEl) {
                subEl = "Other speakers";
            }

            if (!map.has(subEl)) {
                map.set(subEl, [obj]);
            } else {
                map.get(subEl).push(obj);
            }
            return map;
        }, {});
    }

    setFilter(val, timeFilter) {
        let filter;
        if (val === "speakerTypeName") {
            filter = "speakerTypeName";
        } else if (val === "speakerType") {
            filter = "speakerType";
        } else if (val === "organization") {
            filter = "organization";
        } else {
            filter = val;
        }
        return filter;
    }

    groupingSpeaker() {
        if (this.generalDataConfig.topLevel.groupingBy == "speakerTypeName") {
            this.generalDataConfig.topLevel.groupingBy = "speakerType";
        }
        let mainFilter = "";
        if (this.generalDataConfig.topLevel.groupingBy != null) {
            mainFilter = this.setFilter(this.generalDataConfig.topLevel.groupingBy, "topLevel");
            let firstLevelMap = this.reduceHelper(this.speakerList["speakers"], mainFilter);
            this.speakerGroupList = firstLevelMap;
            if(!this.generalDataConfig.hasOwnProperty('sort')) {
                this.generalDataConfig.sort = {};
                this.generalDataConfig.sort.sortOrder = 'asc';
            }
            if(this.generalDataConfig.topLevel.sortingBy && this.speakerGroupList?.size > 0) {
                let sortBy = this.setSorting(this.generalDataConfig.topLevel.sortingBy);
                if(sortBy == 'firstName' || sortBy == 'lastName' || sortBy == 'organization' || sortBy == 'position' || sortBy == 'speakerRank') {
                    this.speakerGroupList.forEach(element => {
                        this.sortStandardFields(element, sortBy);
                    });
                } else {
                    this.speakerGroupList.forEach(element => {
                        this.sortCustomFields(element, sortBy);
                    });
                }
            }

            this.arrangeData(this.speakerGroupList);
        }
    }

    sortStandardFields(grouplist, sortBy) {
        grouplist.sort(( a, b ) => {
            let a1 = a[sortBy] ? sortBy != 'speakerRank' ? a[sortBy].toLowerCase() : a[sortBy] : ''
            let b1 = b[sortBy] ? sortBy != 'speakerRank' ? b[sortBy].toLowerCase() : b[sortBy] : ''
            if(sortBy == 'speakerRank') {
                a1 = a1 ? parseInt(a1) : '';
                b1 = b1 ? parseInt(b1) : '';
            }
            let order1 = a1 > b1;
            let order2 = a1 < b1;
            if(this.generalDataConfig.sort.sortOrder == 'desc') {
                order1 = a1 < b1;
                order2 = a1 > b1;
            }
            if ( order1 ) {
                return 1;
            }
            if ( order2 ) {
                return -1;
            }
            // for second level sorting
            let name1 = a.firstName;
            let name2 = b.firstName;
            if (name1 > name2) return 1;
            if (name1 < name2) return -1;
        });
    }


    sortCustomFields(grouplist, sortBy) {
        grouplist.sort(( a, b ) => {
            console.log("a",a);
            let a1 = '';
            let b1 = '';
            if(a.customFieldMap) {
                a1 = a.customFieldMap[sortBy] || ''
            }

            if(b.customFieldMap) {
                b1 = b.customFieldMap[sortBy] || ''
            }

            let order1 = a1 > b1;
            let order2 = a1 < b1;
            if(this.generalDataConfig.sort.sortOrder == 'desc') {
                order1 = a1 < b1;
                order2 = a1 > b1;
            }
            if ( order1 ) {
            return 1;
            }
            if ( order2 ) {
            return -1;
            }
            // for second level sorting
            let name1 = a.firstName;
            let name2 = b.firstName;
            if (name1 > name2) return 1;
            if (name1 < name2) return -1;
        })
    }

    setSorting(value) {  
        switch (value) {
            case 'fname':
                return 'firstName'
            case 'lname':
                return 'lastName'
            case 'organization':
                return 'organization'
            case 'position':
                return 'position'
            case 'speakerRank':
                return 'speakerRank'
            default:
                return value
        }  
    };

    getLabelStyletr(textConfig) {
        return (
            "background-color: " +
            textConfig.backgroundColor +
            ";" +
            "font-style: " +
            textConfig.fontStyle +
            ";" +
            "text-decoration: " +
            textConfig.fontStyle +
            ";" +
            "font-weight: " +
            textConfig.fontStyle +
            ";" +
            "font-size: " +
            textConfig.fontSize +
            "px" +
            ";" +
            "color: " +
            textConfig.fontColor
        );
    }

    arrangeData(speakerGroupList) {
        this.speakerArrangedList = [];
        let arrangeList = [];
        if (Object.keys(speakerGroupList).length === 0 && speakerGroupList.constructor === Object) {
            this.keysSession = [];
        } else {
            this.keysSession = Array.from(speakerGroupList.keys());
        }
        if (this.generalDataConfig.topLevel.groupingBy != null) {
            let keys = [];
            if(this.generalDataConfig.topLevel.groupingBy != 'speakerType' && this.generalDataConfig.topLevel.groupingBy != 'organization') {
                let obj = this.sharedService.speakerEnumCustomFields.find(element => element.code == this.generalDataConfig.topLevel.groupingBy);    
                
                obj.options.forEach(element => {
                    if(this.keysSession.find(ele => ele == element.name)) {
                        keys.push(element.name);
                    }
                });
                this.keysSession.forEach((e) => {
                    if(e == 'Other speakers') {
                        keys.push('Other speakers')
                    }
                })
                
            }

            if(keys.length ==0) {
                keys = this.keysSession;
            }

            Object.keys(keys).forEach((item) => {
                var l1 = keys[item];
                var lvl1 = speakerGroupList.get(l1);
                this.getKey(speakerGroupList.get(l1));

                arrangeList.push({
                    type: "metadata",
                    break: false,
                    level: "top",
                    groupProperty: l1,
                    styleStr: "general-data-top-level-text"
                });

                for (let index = 0; index < lvl1.length; index++) {
                    lvl1[index].break = true;

                    lvl1[index].type = "data";
                    arrangeList.push(lvl1[index]);
                }
            });
        }

        var idx = 0;
        var fillingFastConfig = this.buttonConfig;
        var datePipe = this.datePipe;

        this.speakerArrangedList = {
            speakers: arrangeList,
            idx: function() {
                return idx++;
            },
            resetIndex: function() {
                idx -= 1;
                return;
            },
            checkNullEmptyString: function() {
                return function(text, render) {
                    if (render(text) == null || render(text) == "") {
                        return false;
                    } else {
                        return render(text);
                    }
                };
            },
            index: function() {
                return idx;
            },
            formatDobDate: function() {
                return function(date, render) {
                    return datePipe.transform(render(date).replace(new RegExp(" ", "g"), "T"), "dd-MMM-yyyy");
                };
            }
        };
        let generalSpeakerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.SPEAKER.general].config
        );

        if (this.generalList != null && this.clearGeneralSessionList) {
            this.generalList.clear();
            this.clearGeneralSessionList = false;
        }
        this.listemplateHelper(generalSpeakerConfig, this.generalList, this.generalListRef, "general", "");
    }

    prepareDateTime(obj) {
        var d1 = this.datePipe.transform(obj, this.generalDataConfig.dateTimeFormats.dateFormat);

        var t1 = this.datePipe.transform(obj, this.generalDataConfig.dateTimeFormats.timeFormat);
        return d1 + " " + t1;
    }

    getKey(obj) {
        return Object.keys(obj);
    }

    sessionCustomFieldFileDownloadHelper(template) {
        var matches = template.match(new RegExp("({@ddf.customFieldMap.)(.*?)(?=})", "g"));
        matches = uniq(matches);
        if (matches != null && matches.length > 0) {
            matches.forEach((code) => {
                this.customFieldDdfRegx.lastIndex = 0;
                code = this.customFieldDdfRegx.exec(code)[2];
                this.sharedService.sessionFileCustomFields.forEach((element) => {
                    if (code == element.code.replace(/ /g, "") && element.questionTypeId == 19) {
                        var ddf = "{@ddf.customFieldMap." + code + "@}";
                        template = template.replace(
                            new RegExp(ddf, "g"),
                            '<span class="sessionFiles cursor-pointer" data-filename="' +
                                ddf +
                                '" data-documentType="Custom" data-eventId="' +
                                this.sharedService.event.id +
                                '" data-sessionId="{@ddf.sessionId@}">' +
                                ddf +
                                " </span>"
                        );
                    }
                });
            });
        }
        return template;
    }

    customFieldFileOnSpeakerListDownloadHelper(template) {
        var matches = template.match(new RegExp("({@ddf.customFieldMap.)(.*?)(?=})", "g"));
        matches = uniq(matches);
        if (matches != null && matches.length > 0) {
            matches.forEach((code) => {
                this.customFieldDdfRegx.lastIndex = 0;
                code = this.customFieldDdfRegx.exec(code)[2];
                this.sharedService.speakerFileCustomFields.forEach((element) => {
                    if (code == element.code.replace(/ /g, "") && element.questionTypeId == 19) {
                        var ddf = "{@ddf.customFieldMap." + code + "@}";
                        template = template.replace(
                            new RegExp(ddf, "g"),
                            '<span class="cursor-pointer" title="Download Document" (cclClick)=\'downloadSpeakerDocument($event,"{@ddf.eventId@}","' +
                                ddf +
                                '","Custom","{@ddf.speakerId@}")\'>' +
                                ddf +
                                " </span>"
                        );
                    }
                });
            });
        }
        return template;
    }

    customFieldFileSpeakerDownloadHelper(template) {
        var matches = template.match(new RegExp("({@ddf.customFieldMap.)(.*?)(?=})", "g"));
        matches = uniq(matches);
        if (matches != null && matches.length > 0) {
            matches.forEach((code) => {
                this.customFieldDdfRegx.lastIndex = 0;
                code = this.customFieldDdfRegx.exec(code)[2];
                this.sharedService.speakerFileCustomFields.forEach((element) => {
                    if (code == element.code.replace(/ /g, "") && element.questionTypeId == 19) {
                        var ddf = "{@ddf.customFieldMap." + code + "@}";
                        template = template.replace(
                            new RegExp(ddf, "g"),
                            '<span class="speakerCustomFile cursor-pointer" data-filename="' +
                                ddf +
                                '" data-documentType="Custom" data-eventId="' +
                                this.sharedService.event.id +
                                '" data-speakerId="{@ddf.id@}" >' +
                                ddf +
                                " </span>"
                        );
                    }
                });
            });
        }

        return template;
    }

    getSafeHtmlDescStr(template) {
        template = template.replace(new RegExp("{@ddf.abstractDesc@}", "g"), "<div>{@ddf.&abstractDesc@}</div>");
        template = template.replace(new RegExp("{@ddf.biography@}", "g"), "{@ddf.&biography@}");
        template = template.replace(new RegExp("{@ddf.bio@}", "g"), "{@ddf.&bio@}");
        return template.replace(
            new RegExp("{@ddf.sessionDescription@}", "g"),
            "<div>{@ddf.&sessionDescription@}</div>"
        );
    }

    createStyleString(styleConfig) {
        return (
            "{'margin' : '" +
            styleConfig.regionConfig.margin +
            "'," +
            "'padding': '" +
            styleConfig.regionConfig.padding +
            "'," +
            "'background': '" +
            styleConfig.regionConfig.background +
            "'," +
            "'border-radius': '" +
            styleConfig.regionConfig.corner +
            "'}"
        );
    }

    fromAttedee(list, groupConfig) {
        this.fromAttendee = true;
        var customTags = ["{@ddf.", "@}"];
        this.mustache.tags = customTags;
        this.generalDataConfig = groupConfig;
        this.previewAttendeeSide(list);
    }

    createStyleString2(styleConfig) {
        return {
            margin: styleConfig.regionConfig.margin,
            padding: styleConfig.regionConfig.padding,
            background: styleConfig.regionConfig.background,
            "border-radius": styleConfig.regionConfig.corner
        };
    }

    createTextStyle(styleConfig, imgWidth, imgLayout) {
        return (
            "{'background': '" +
            styleConfig.textConfig.background +
            "'," +
            "'width': '" +
            (imgLayout != "l_noimage" &&
            imgLayout != "l_banner" &&
            this.sharedService.catalogLayoutConfig.listType != "card"
                ? "calc(98% - " + imgWidth + ")"
                : "100%") +
            "'," +
            "'color': '" +
            styleConfig.textConfig.textColor +
            "'}"
        );
    }

    createImageStyle(styleConfig, layout) {
        if (layout != "l_noimage" && layout != "l_banner") {
            let divStyle =
                "height: " +
                styleConfig.imageConfig.height +
                ";" +
                "width: " +
                styleConfig.imageConfig.width +
                ";" +
                "background: " +
                styleConfig.imageConfig.background +
                ";" +
                "margin-top: " +
                styleConfig.imageConfig.margin +
                ";" +
                "margin-bottom: " +
                styleConfig.imageConfig.margin +
                ";" +
                "border-radius: " +
                (layout === "l_circular" ? styleConfig.imageConfig.height : "0px") +
                ";";
            let imgStyle =
                "height: " +
                styleConfig.imageConfig.height +
                ";" +
                "width: " +
                styleConfig.imageConfig.width +
                ";" +
                "border-radius: " +
                (layout === "l_circular" ? styleConfig.imageConfig.height : "0px") +
                ";";
            if (styleConfig.imageConfig.background != null && styleConfig.imageConfig.background.trim().length != 0) {
                imgStyle +=
                    "-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */ filter: grayscale(100%); opacity: 0.80;-moz-opacity: 80%;-webkit-opacity: 80%;";
            }
            return {
                div: divStyle,
                img: imgStyle
            };
        } else if (layout === "l_banner") {
            return {
                div: "",
                img:
                    "height: calc(100% - 2 * " +
                    styleConfig.imageConfig.margin +
                    ");width: calc(100% - 2 * " +
                    styleConfig.imageConfig.margin +
                    ");margin: " +
                    styleConfig.imageConfig.margin +
                    ";"
            };
        } else {
            return {
                div: "",
                img: ""
            };
        }
    }

    ngAfterViewInit(): void {
        if (!this.isLoggedIn && this.sharedService.loginPopup == "open") {
            this.openLoginPopup("login");
        }
    }

    ngOnDestroy() {
        if (this.highlightedListRef) {
            this.highlightedListRef.destroy();
        }
        if (this.promotedListRef) {
            this.promotedListRef.destroy();
        }
        if (this.generalListRef) {
            this.generalListRef.destroy();
        }
        this.sharedService.unsubscribeHelper(this.subscription);
        this.sharedService.unsubscribeHelper(this.subscription2);
    }

    openPopup(item) {
        this.sharedService.currentPopup = {
            title: null,
            navLinks: null,
            saveMessage: null,
            showFooter: false
        };
        let url = "popup/default-setup";
        this.sharedService.navigateToOutlet("popup", url);
    }

    showSideBar: boolean = false;
    toggleSideBar() {
        this.showSideBar = !this.showSideBar;
    }

    mySessionCheckbox() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.nospeakersAvailable = false;
        this.filterResults = true;
        this.filters.mySessions = true;
        this.filters.fetchFavInstanceList = false;
        this.getSpeakerList();
    }

    myFavCheckbox() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.nospeakersAvailable = false;
        this.filterResults = true;
        this.filters.mySessions = false;
        this.filters.fetchFavInstanceList = true;
        this.getSpeakerList();
    }

    mySessionFilterClear() {
        this.esPage = 0;
        this.clearGeneralSessionList = true;
        this.nospeakersAvailable = false;
        this.filterResults = true;
        this.filters.mySessions = false;
        this.filters.fetchFavInstanceList = false;
    }

    @ViewChild("highlightedList", { read: ViewContainerRef })
    highlightedList: ViewContainerRef;

    @ViewChild("promotedList", { read: ViewContainerRef })
    promotedList: ViewContainerRef;

    @ViewChild("generalList", { read: ViewContainerRef })
    generalList: ViewContainerRef;

    private highlightedListRef: ComponentRef<any>;
    private promotedListRef: ComponentRef<any>;
    private generalListRef: ComponentRef<any>;

    // Here we create the component.
    private createComponentFromRaw(
        param: any,
        template: string,
        mustache: any,
        sessionList: any,
        compRef: any,
        cmpRef: any
    ) {
        // Let's say your template looks like `<h2><some-component [data]="data"></some-component>`
        // As you see, it has an (existing) angular component `some-component` and it injects it [data]

        // Now we create a new component. It has that template, and we can even give it data.
        template = template.replace(/{/g, '&#123;');
        template = template.replace(/}/g, '&#125;');
        
        template = template
            .replace(new RegExp('contenteditable="true"', "g"), "")
            .replace(new RegExp("contenteditable='true'", "g"), ""); //to remove editable
        const tmpCmp = Component({ template: template, selector: 'scTmpCmp' })(
            class {
                [x: string]: any;
                params: any = param;
                // the class is anonymous. But it's a quite regular angular class. You could add @Inputs,
                // @Outputs, inject stuff etc.

                createSpeakerTemplate(imgStyle, textStyleStr, output2, speaker, imageBasedOn, bannerImage) {
                    //for always using general-speaker classes for biography popup
                    param["class"] = "general-speaker";
                    //for always using general-speaker layout for biography popup
                    param["layout"] = param["bioLayout"];
                    textStyleStr = textStyleStr + ";box-sizing: border-box;padding-right: 15px";
                    if (param["layout"] != "l_noimage" && param["layout"] != "l_banner") {
                        let imagePath = "assets/images/blank_profile.jpg";
                        if (imageBasedOn === "speaker_img" && speaker != undefined) {
                            if (speaker.profilePicURL != "" && speaker.profilePicURL != null) {
                                imagePath = speaker.profilePicURL;
                            }
                        }
                        if (imageBasedOn === "dynamic_img") {
                            if (param["bodyDynamicImg"] != "") {
                                imagePath = param["bodyDynamicImg"];
                            }
                        }
                        if (param["sharedService"].catalogLayoutConfig.listType == "card") {
                            return (
                                '<div class="attendee-speaker-list-img-container ' +
                                `${param["class"]}-catalog-body-container` +
                                '"><img alt="Speaker Image" src="' +
                                imagePath +
                                '" class="' +
                                `${param["class"]}-catalog-body-img` +
                                '"></div>' +
                                "<div class='attendee-session-list-text-container " +
                                `${param["class"]}-catalog-body-text` +
                                " ' {@ddf.resetIndex@}" +
                                ">" +
                                output2 +
                                "</div>"
                            );
                        } else {
                            return (
                                '<div class="attendee-session-list-img-container ' +
                                `${param["class"]}-catalog-body-container catalog-img-container` +
                                '"><img alt="Speaker Image" src="' +
                                imagePath +
                                '" class="' +
                                `${param["class"]}-catalog-body-img` +
                                '"></div>' +
                                "<div class='attendee-session-list-text-container " +
                                `${param["class"]}-catalog-body-text` +
                                " ' {@ddf.resetIndex@}" +
                                ">" +
                                output2 +
                                "</div>"
                            );
                        }
                    } else {
                        return (
                            (param["layout"] === "l_banner" && bannerImage != undefined
                                ? '<div><img alt="Banner Image" src="' +
                                  bannerImage +
                                  '" class="general-speaker-catalog-body-img' +
                                  '"></div>'
                                : "") +
                            "<div class='attendee-session-list-text-container " +
                            `${param["class"]}-catalog-body-text` +
                            " ' {@ddf.resetIndex@}" +
                            ">" +
                            output2 +
                            "</div>"
                        );
                    }
                }

                downloadSpeakerDocument(event, eventId, documentName, documentType, speakerId) {
                    event.stopPropagation();
                    param["attendeeSessionService"]
                        .downloadSpeakerDocument(eventId, documentName, documentType, speakerId)
                        .subscribe((resp) => {
                            FileSaver.saveAs(resp.body, documentName);
                        });
                }

                openModel(event, speakerId, eventUUID, index) {
                    event.stopPropagation();
                    var speakerData;
                    var filter = {
                        section: "GENERAL_SPEAKER_CONFIG",
                        speakerIds: [speakerId]
                    };

                    param["speakerService"].getSpeakersEs(filter).subscribe(
                        (resp) => {
                            if (resp.body != null && resp.body["speakers"].length > 0) {
                                speakerData = {
                                    speaker: resp.body["speakers"][0],
                                    formatDobDate: function() {
                                        return function(date, render) {
                                            return param["datePipe"].transform(render(date), "dd-MMM-yyyy");
                                        };
                                    }
                                };
                                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/,/g, "; ");
                                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/[{}']/g, "");
                                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/,/g, "; ");
                                param["bodyStyleStr"] = param["bodyStyleStr"].replace(/[{}']/g, "");

                                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/[{}']/g, "");
                                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/,/g, "; ");
                                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/,/g, "; ");
                                param["bodyTextStyleStr"] = param["bodyTextStyleStr"].replace(/[{}']/g, "");

                                var output = mustache.render(
                                    "{@ddf.#speaker@}" +
                                        this.createSpeakerTemplate(
                                            param["bodyImgStyle"],
                                            param["bodyTextStyleStr"],
                                            param["bodyTemplate"],
                                            speakerData.speaker,
                                            param["bodyImgBasedOn"],
                                            param["bodyBanner"]
                                        ) +
                                        "{@ddf./speaker@}",
                                    speakerData
                                );

                                const modalData: Object = {
                                    speakerInfo: {
                                        speakerDetails: output,
                                        speakerId: speakerId,
                                        speaker: speakerData.speaker
                                    }
                                };

                                param["modalService"].setModalData(modalData, "myModal", true);
                                param["modalService"].open("myModal", false);
                            } else {
                                const modalData: Object = {
                                    speakerInfo: { speakerDetails: "Unable to load speaker data", speakerId: speakerId }
                                };

                                param["modalService"].setModalData(modalData, "myModal", true);
                                param["modalService"].open("myModal", false);
                            }
                        },
                        (err) => {
                            const modalData: Object = {
                                speakerInfo: { speakerDetails: "Unable to load speaker data", speakerId: speakerId }
                            };

                            param["modalService"].setModalData(modalData, "myModal", true);
                            param["modalService"].open("myModal", false);
                        }
                    );
                }

                showAllInstances(event, sessionId, instanceId) {
                    event.stopPropagation();
                    var filter: any = {};
                    filter["sessionIds"] = [sessionId];
                    param["attendeeSessionService"].getSessions(filter).subscribe((resp) => {
                        if (resp.body != null && resp.body["sessions"].length > 0) {
                            let otherSessions = [];
                            resp.body["sessions"].forEach((element) => {
                                if (element.id != instanceId) {
                                    otherSessions.push(element);
                                }
                            });
                            if (otherSessions.length == 0) {
                                param["_flashMessagesService"].show("There are no other session instances.", {
                                    cssClass: "alert-danger"
                                });
                                return false;
                            }
                            var idx = 1;
                            var sessionList = {
                                speakers: otherSessions,
                                formatStartDate: function() {
                                    return function(date, render) {
                                        return param["datePipe"].transform(render(date), "MMM d, yyyy, h:mm a");
                                    };
                                },
                                formatEndDate: function() {
                                    return function(date, render) {
                                        return param["datePipe"].transform(render(date), "h:mm a");
                                    };
                                },
                                idx: function() {
                                    return idx++;
                                },
                                index: function() {
                                    return idx;
                                }
                            };

                            var output = mustache.render(
                                '{@ddf.#speakers@}<div class="row" style="border-bottom: 3px solid #F2F2F2;padding: 10px;"><div class="col-sm-1" style="color: #2fb36d;text-align: center;" title="{@ddf.instanceCode@}">{@ddf.idx@}</div><div class="col-sm-11" style="padding-right: 0px;" title="{@ddf.instanceCode@}"><strong>Date & Time: </strong>{@ddf.#formatStartDate@}{@ddf.startTime@}{@ddf./formatStartDate@} - {@ddf.#formatEndDate@}{@ddf.endTime@}{@ddf./formatEndDate@} <br><strong>Location:</strong> {@ddf.locationName@}</div></div>{@ddf./speakers@}',
                                sessionList
                            );
                            const modalData: Object = {
                                modalContent: output
                            };
                            param["modalService"].setModalData(modalData, "instanceModal", true);
                            param["modalService"].open("instanceModal", false);
                        } else {
                            param["_flashMessagesService"].show("There are no session instance(s) for this session.", {
                                cssClass: "alert-danger"
                            });
                            return false;
                        }
                    });
                }
                isNotProcessingSession = Object.assign([], param["toggle"]);
                showAddToCart = Object.assign([], param["showAddToCart"]);
                addSessionToCart(event, instanceId, index, addToFavourite: boolean) {
                    event.stopPropagation();
                    if (!this.isNotProcessingSession[index]) {
                        return false;
                    }
                    this.isNotProcessingSession[index] = false;
                    param["sharedService"].showLoader = false;

                    if (addToFavourite) {
                        var cartObjbect = {
                            registrationUUID: param["loggedInAttendee"].uuid,
                            confSessionInstanceId: instanceId
                        };
                        param["attendeeSessionService"].addToCart(cartObjbect).subscribe(
                            (resp) => {
                                if (resp["body"].hasOwnProperty("registrationConfSessionInstanceCartDTO")) {
                                    this.showAddToCart[index] = false;
                                    this.isNotProcessingSession[index] = true;
                                    param["sharedService"].showLoader = true;
                                }
                            },
                            (err) => {
                                this.isNotProcessingSession[index] = true;
                                param["sharedService"].showLoader = true;
                            }
                        );
                    } else {
                        param["attendeeSessionService"]
                            .processFav(param["loggedInAttendee"].uuid, instanceId)
                            .subscribe(
                                (resp) => {
                                    if (resp["body"].hasOwnProperty("status") && resp["body"].status == "200") {
                                        this.showAddToCart[index] = false;
                                        this.isNotProcessingSession[index] = true;
                                        param["sharedService"].showLoader = true;
                                    }
                                },
                                (err) => {
                                    this.isNotProcessingSession[index] = true;
                                    param["sharedService"].showLoader = true;
                                }
                            );
                    }
                }

                isEnrolled = Object.assign([], param["isEnrolled"]);
                isWaitListed = Object.assign([], param["isWaitListed"]);
                isGoingToBeWaitlisted = Object.assign([], param["isGoingToBeWaitlisted"]);
                showButton = Object.assign([], param["showButton"]);
                registerSession(event, instanceId, index, addToFavourite: boolean) {
                    event.stopPropagation();
                    if (!this.isNotProcessingSession[index]) {
                        return false;
                    }
                    this.isNotProcessingSession[index] = false;
                    param["sharedService"].showLoader = false;
                    var cartObjbect = {
                        registrationUUID: param["loggedInAttendee"].uuid,
                        confSessionInstanceId: instanceId
                    };
                    param["attendeeSessionService"].addToCart(cartObjbect).subscribe(
                        (resp) => {
                            if (resp["body"].hasOwnProperty("registrationConfSessionInstanceCartDTO")) {
                                param["attendeeSessionService"].processCart(param["loggedInAttendee"].uuid).subscribe(
                                    (response) => {
                                        this.isNotProcessingSession[index] = true;
                                        param["sharedService"].showLoader = true;
                                        if (response.body.failed.length > 0) {
                                            for (let i = 0; i < response.body.failed.length; ++i) {
                                                if (response.body.failed[i] + "" === instanceId) {
                                                    param["_flashMessagesService"].show(
                                                        response.body.data[instanceId],
                                                        {
                                                            cssClass: "alert-danger"
                                                        }
                                                    );
                                                    return;
                                                }
                                            }
                                        }
                                        if (response.body.registered.length > 0) {
                                            for (let i = 0; i < response.body.registered.length; ++i) {
                                                if (response.body.registered[i] + "" === instanceId) {
                                                    this.isEnrolled[index] = true;
                                                    this.showAddToCart[index] = false;
                                                    this.registrationSessionStatusId[index] = 1;
                                                    return;
                                                }
                                            }
                                        }
                                        if (response.body.waitlisted.length > 0) {
                                            for (let i = 0; i < response.body.waitlisted.length; ++i) {
                                                if (response.body.waitlisted[i] + "" === instanceId) {
                                                    this.isWaitListed[index] = true;
                                                    this.showAddToCart[index] = false;
                                                    return;
                                                }
                                            }
                                        }
                                    },
                                    (err) => {
                                        param["sharedService"].showLoader = true;
                                    }
                                );
                            } else {
                                this.isNotProcessingSession[index] = true;
                                param["sharedService"].showLoader = true;
                            }
                        },
                        (err) => {
                            this.isNotProcessingSession[index] = true;
                            param["sharedService"].showLoader = true;
                        }
                    );
                }

                addToFavourite = Object.assign([], param["favFlag"]);
                registrationSessionStatusId = Object.assign([], param["registrationSessionStatusId"]);
                addSessionToFavourite(event, index, instanceId) {
                    event.stopPropagation();
                    var favObjbect = {
                        registrationUUID: param["loggedInAttendee"].uuid,
                        confSessionInstanceId: instanceId
                    };
                    this.addToFavourite[index] = false;
                    param["sharedService"].showLoader = false;
                    param["attendeeSessionService"].addToFavourite(favObjbect).subscribe(
                        (resp) => {
                            param["sharedService"].showLoader = true;
                            if (resp["body"].hasOwnProperty("confSessionInstanceId")) {
                                this.addToFavourite[index] = false;
                            }
                        },
                        (err) => {}
                    );
                }

                isNotExcluded = Object.assign([], param["toggle"]);
                sessionData = Object.assign([], param["sessionData"]);
                excludeSession(event, index, instanceId) {
                    event.stopPropagation();

                    var m = "<div>Are you sure you want to hide this session ?</div>";
                    const pnotify = param["notifyService"].getPNotify();
                    pnotify.alert({
                        title: "Don't show this session again.",
                        text: m,
                        addClass: "c-pnotify-confirm",
                        hide: false,
                        textTrusted: true,
                        modules: {
                            Confirm: {
                                confirm: true,
                                align: "flex-end",
                                buttons: [
                                    {
                                        text: "No",
                                        textTrusted: false,
                                        addClass: "",
                                        primary: true,
                                        promptTrigger: true,
                                        click: (notice, value) => {
                                            notice.close();
                                            notice.fire("pnotify.confirm", { notice, value });
                                        }
                                    },
                                    {
                                        text: "Yes",
                                        textTrusted: false,
                                        addClass: "",
                                        primary: true,
                                        promptTrigger: true,
                                        click: (notice, value) => {
                                            var excObjbect = {
                                                registrationUUID: param["loggedInAttendee"].uuid,
                                                confSessionInstanceId: instanceId,
                                                isExcluded: true
                                            };
                                            param["sharedService"].showLoader = false;

                                            if (
                                                this.sessionData[index + 1] == true &&
                                                this.sessionData[index - 1] == true &&
                                                this.isNotExcluded[index + 1] == true &&
                                                this.isNotExcluded[index - 1] == true
                                            ) {
                                                //its between sessions
                                            } else if (
                                                this.sessionData[index - 1] == true &&
                                                this.isNotExcluded[index - 1] == true
                                            ) {
                                                //its below sessions
                                            } else if (
                                                this.sessionData[index - 1] == false &&
                                                this.sessionData[index + 1] == false
                                            ) {
                                                //it has grouping heading and is only one in it
                                                for (let i = index - 1; i >= 0; --i) {
                                                    if (this.sessionData[i] == true) {
                                                        break;
                                                    } else {
                                                        //to hide heading
                                                        this.isNotExcluded[i] = false;
                                                    }
                                                }
                                            } else if (
                                                this.isNotExcluded[index - 1] == false &&
                                                this.sessionData[index - 1] == true
                                            ) {
                                                //the session above is exculed so loop to heading
                                                for (let i = index - 2; i >= 0; --i) {
                                                    if (this.sessionData[i] == true && this.isNotExcluded[i] == true) {
                                                        //its between sessions
                                                        break;
                                                    } else {
                                                        //to hide heading
                                                        this.isNotExcluded[i] = false;
                                                    }
                                                }
                                            }
                                            //to hide session
                                            this.isNotExcluded[index] = false;
                                            if (param["sharedService"].hasOwnProperty("excData")) {
                                                param["sharedService"].excData.size += 1;
                                            } else {
                                                param["sharedService"]["excData"].size = 1;
                                            }
                                            if (
                                                param["sharedService"].excData.size ===
                                                param["sharedService"].totalCountOfGeneralSessions
                                            ) {
                                                param["sharedService"].allSessionsHidden = true;
                                                param["sharedService"].onScroll();
                                            }

                                            param["attendeeSessionService"].addToFavourite(excObjbect).subscribe(
                                                (resp) => {
                                                    param["sharedService"].showLoader = true;
                                                },
                                                (err) => {}
                                            );
                                            notice.close();
                                            notice.fire("pnotify.confirm", { notice, value });
                                        }
                                    }
                                ]
                            },
                            Buttons: {
                                closer: false,
                                sticker: false
                            }
                        },
                        stack: {
                            modal: true
                        }
                    });
                }

                removeSessionFromFavourite(event, index, instanceId) {
                    event.stopPropagation();
                    param["sharedService"].showLoader = false;
                    this.addToFavourite[index] = true;
                    param["attendeeSessionService"]
                        .removeFromFavourite(param["loggedInAttendee"].uuid, instanceId)
                        .subscribe(
                            (resp) => {
                                param["sharedService"].showLoader = true;
                                if (resp["body"].hasOwnProperty("status") && resp["body"].status === "200") {
                                    this.addToFavourite[index] = true;
                                }
                            },
                            (err) => {}
                        );
                }

                ngOnInit() {
                    /* do stuff here in the dynamic component */
                }
                toggle = param["toggle"];
                toggleView(event, index) {
                    event.stopPropagation();
                }

                findIndex(id) {
                    let index = -1;
                    if (param["instanceId"] != null) {
                        index = param["instanceId"].indexOf(id);
                    }
                    return index;
                }

                listen(message) {
                    if (param["type"] == "general-") {
                        if (message.text === "single-remove-cart") {
                            let idx = this.findIndex(message.data);
                            if (idx >= 0) {
                                this.showAddToCart[idx] = true;
                                this.addToFavourite[idx] = true;
                            }
                        } else if (message.text === "clear-cart") {
                            message.data.forEach((element) => {
                                let idx = this.findIndex(element);
                                if (idx >= 0) {
                                    this.showAddToCart[idx] = true;
                                    this.addToFavourite[idx] = true;
                                }
                            });
                        } else if (message.text === "single-remove-fav") {
                            let idx = this.findIndex(message.data);
                            if (idx >= 0) {
                                this.addToFavourite[idx] = true;
                            }
                        } else if (message.text === "remove-all-fav") {
                            message.data.forEach((element) => {
                                let idx = this.findIndex(element);
                                if (idx >= 0) {
                                    this.addToFavourite[idx] = true;
                                }
                            });
                        } else if (message.text === "move-fav-to-cart") {
                            let idx = this.findIndex(message.data);
                            if (idx >= 0) {
                                this.showAddToCart[idx] = false;
                                this.addToFavourite[idx] = true;
                            }
                        } else if (message.text === "add-all-fav-to-cart") {
                            message.data.forEach((element) => {
                                let idx = this.findIndex(element);
                                if (idx >= 0) {
                                    this.showAddToCart[idx] = false;
                                    this.addToFavourite[idx] = true;
                                }
                            });
                        } else if (message.text === "process-cart") {
                            if (message.data["registered"].length > 0) {
                                message.data.registered.forEach((element) => {
                                    let idx = this.findIndex(element);
                                    if (idx >= 0) {
                                        this.isEnrolled[idx] = true;
                                        this.showAddToCart[idx] = false;
                                        this.registrationSessionStatusId[idx] = 1;
                                    }
                                });
                            }

                            if (message.data["waitlisted"].length > 0) {
                                message.data.waitlisted.forEach((element) => {
                                    let idx = this.findIndex(element);
                                    if (idx >= 0) {
                                        this.isWaitListed[idx] = true;
                                        this.showAddToCart[idx] = false;
                                    }
                                });
                            }

                            if (message.data["failed"].length > 0) {
                                message.data.failed.forEach((element) => {
                                    let idx = this.findIndex(element);
                                    if (idx >= 0) {
                                        this.showAddToCart[idx] = true;
                                    }
                                });
                            }
                        }
                    }
                }
            }
        );

        // Now, also create a dynamic module.
        const tmpModule = NgModule({
            imports: [RouterModule, CommonModule, CclSharedModule],
            declarations: [tmpCmp]
            // providers: [] - e.g. if your dynamic component needs any service, provide it here.
        })(class {});

        // Now compile this module and component, and inject it into that #generalList in your current component template.
        this.compiler.compileModuleAndAllComponentsAsync(tmpModule).then((factories) => {
            const f = factories.componentFactories.find(element => element.selector === 'scTmpCmp');
            cmpRef = f.create(this.injector, [], null, this.moduleRef);
            cmpRef.instance.name = "my-dynamic-component";
            if (this.fromAttendee) {
                this.sharedService.generalPreviewRef = cmpRef;
                this.sharedService.generalPreviewRefRender = true;
                this.sharedService.renderView();
            } else {
                this.subscription2 = this.messageService
                    .getMessage()
                    .subscribe((message) => cmpRef.instance.listen(message));
                compRef.insert(cmpRef.hostView);
                this.sharedService.showLoader = true;
                if (cmpRef?.instance?.params && cmpRef.instance.params["type"] == "general-") {
                }
                this.loadingList = false;
                this.sharedService.generalListLoading = false;
            }
        });
    }
}
